import { Fragment, useState, useCallback, useRef, useEffect } from 'react';
import {
  Accordion, AccordionSummary, AccordionDetails, Alert, Backdrop, Button, Box, Checkbox, Collapse, DialogTitle, Dialog, Grow, Fab, FormControl, FormControlLabel, InputAdornment, InputLabel, Select, MenuItem, Typography, DialogContent, DialogActions, TextField, createFilterOptions, Card, CardHeader, CardContent, Autocomplete, Tab, Tabs,
  LinearProgress, Divider, Paper, Popover, styled, Slider, Snackbar, Tooltip as MuiTooltip
} from '@mui/material';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { saveAs } from 'file-saver';
import { TransitionGroup } from 'react-transition-group';
import { AttachMoney } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ReplayIcon from '@mui/icons-material/Replay';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CampaignIcon from '@mui/icons-material/Campaign';
import SafetyDividerIcon from '@mui/icons-material/SafetyDivider';
import ArticleIcon from '@mui/icons-material/Article';
import StarsIcon from '@mui/icons-material/Stars';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PaidIcon from '@mui/icons-material/Paid';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloseIcon from "@mui/icons-material/Cancel"
import DoneIcon from "@mui/icons-material/Done"
import { FaFacebookSquare, FaInstagram, FaWhatsapp, FaMobileAlt, FaBan } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentUser, selectCurrentToken } from "../../../redux/reducers/authSlice";
import { AutocompleteElement, FormContainer, MultiSelectElement, SelectElement, TextFieldElement, SliderElement } from 'react-hook-form-mui';
import {
  DataGridPro, GridToolbarQuickFilter, gridNumberComparator, GridToolbar, GridActionsCellItem, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton,
  GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton
} from '@mui/x-data-grid-pro';
import FileViewer from 'react-file-viewer';
import Grid from "@mui/material/Grid";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from "@mui/icons-material/Delete";
import { ArrowCircleLeftRounded, ArrowCircleRightRounded } from '@mui/icons-material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import VerifiedIcon from '@mui/icons-material/Verified';
import ClearIcon from '@mui/icons-material/Clear';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import theme from "../../../theme";
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js'; // Assuming you have installed the library with npm

import dayjs from "dayjs";
import { removeEmpty } from "../../../lib/utils/index.js";
import * as XLSX from 'xlsx';
import { getMinutaContrato, getConversionesCAC, getIndiceAt, CAC2nominal, getImporteNuevoMes, nominal2CAC, getEstadosHistoricosCDC } from '../../../edilia/index'
import { MinutaContrato } from '../../../edilia/MinutaContrato'
import _ from 'lodash'
import * as types from '../../../edilia/types';

import { getHistoriaFunc } from "../../../redux/reducers/_contratosSlice";
//import { ReactComponent as Contract } from '../../../contract.html';
import React, { PureComponent } from 'react';
import { ComposedChart, ReferenceLine, Line, Area, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Scatter, ResponsiveContainer, ReferenceArea } from 'recharts';
import './ContratosCat.css';
import ClipLoader from "react-spinners/ClipLoader";
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";
import { motion, useAnimate, usePresence, AnimatePresence } from "framer-motion"
import { getContratosData, editContrato, deleteContrato, addDoc, delDoc, getInfoContrato, firmarContrato } from "./contratosSlice.js";

let thread = null;

const MESES_LAG = 2;
const moneyFormat = (v) => "$" + new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(parseFloat(v) / 100).replace("ARS", "");
const moneyFormatMinuta = (v) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((parseFloat(v))?.toFixed(2)).replace("ARS", "");
const getLabel = (option) => {
  if (option.personaFisica) {
    if (!option.nombre && !option.apellido && !option.numeroDocumento) return option.email;
    return option.nombre + ' ' + option.apellido + ' - ' + option.numeroDocumento;
  } else {
    if (!option.denominacionSocial && !option.cuit) return option.email;
    return option.denominacionSocial + ' - ' + option.cuit;
  }
};
function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
};
function getFecha(date) {
  date = new Date(parseInt(date)).toLocaleString().split(",");
  date = date[0].split("/");

  let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
  let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
  let y = date[2];
  return d + '/' + m + '/' + y
};
const fechaSortComparator = (v1, v2, param1, param2) => {
  function getFechaNumero(date) {
    date = date.split('/')
    let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
    let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
    let y = date[2];
    var fullDate = y + m + d;
    return parseInt(fullDate);
  }
  let fecha1 = getFechaNumero(param1.value)
  let fecha2 = getFechaNumero(param2.value)
  const ComparatorResult = gridNumberComparator(
    fecha1,
    fecha2,
  );
  if (ComparatorResult !== 0) {
    return ComparatorResult;
  }
  return gridNumberComparator(v1.name, v2.name, param1, param2);
};
const ContratosCat = () => {
  const currentUser = useSelector(selectCurrentUser);
  const token = useSelector(selectCurrentToken)
  const dispatch = useDispatch();
  const Header = (props) => {
    return (<Fragment>
      <Typography
        variant="h5"
        component="div"
        sx={{
          minWidth: 275, margin: "10px",
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <SummarizeIcon sx={{ marginRight: '5px', color: theme.palette.secondary.dark }} />
        {'Contratos'}</Typography>
    </Fragment>);
  };
  const ContratosTable = (props) => {
    //-------------FORM PARA EDITAR CONTRATO
    const [contratoParaEditar, setContratoParaEditar] = useState(null);
    const [showEditarContratoForm, setShowEditarContratoForm] = useState(false);
    const [showDeleteContratoConfirmation, setShowDeleteContratoConfirmation] = useState(false);
    const [showUploadForm, setShowUploadForm] = useState(false);
    //A: aca guardamos el contrato que el usuario eligio para editar
    const [sociosParaEditar, setSociosParaEditar] = useState(null); //A: aca guardamos los socios, son una lista separada
    const [campanasParaEditar, setCampanasParaEditar] = useState(null);


    const [contratoSeleccionado, setContratoSeleccionado] = useState(null);
    const [firmarContratoModal, setFirmarContratoModal] = useState(false);
    const [perfeccionarContratoModal, setPerfeccionarContratoModal] = useState(false);
    const [erroresFechaFirma, setErroresFechaFirma] = useState(false);
    const [showDetallesContrato, setShowDetallesContrato] = useState(false);
    const [info, setInfo] = useState((useSelector(state => state.contratos.infoContrato) || {}))
    //----------DATA
    const fetching = useSelector(state => state.contratos.fetching);
    const { contratos, clasesContratos, titularidades, personas, rolesPersonasMap, roles, indices, campanas, tiposCampana, documentos } = useSelector(state => state.contratos.data);

    useEffect(() => { dispatch(getContratosData()) }, []);
    useEffect(() => { dispatch(getHistoriaFunc()); }, [currentUser]);
    useEffect(() => { dispatch(getInfoContrato(contratoSeleccionado)) }, [contratoSeleccionado]);
    const getIndiceAt = (fecha = new Date(), difMeses = 0) => {
      function fechaNMesesAntes(ts, N) {
        let fecha = new Date(ts);
        fecha.setMonth(fecha.getMonth() + N);
        return fecha;
      };

      if (indices == null) return 1;
      fecha = new Date(typeof fecha === 'string' ? parseInt(fecha) : fecha);
      fecha = fechaNMesesAntes(fecha.getTime(), difMeses);
      return (indices || [])
        .filter(i => {
          const iFecha = new Date(parseInt(i.fecha));
          return iFecha.getFullYear() === fecha.getFullYear() && iFecha.getMonth() === fecha.getMonth();
        }).sort((a, b) => a.fecha - b.fecha)[0];
    };
    function mapContratoToFormProps(contrato) {
      let vendedor = personas?.find(p => p.personaId === contrato.vendedorId);
      let referenciado = personas?.find(p => p.personaId === contrato.referenciadoId);
      let refuerzo = false
      if (parseInt(contrato.mesRefuerzoSemestral1) === 0 && parseInt(contrato.mesRefuerzoSemestral2) === 6 || parseInt(contrato.mesRefuerzoSemestral1) === 5 && parseInt(contrato.mesRefuerzoSemestral2) === 11) {
        refuerzo = true
      };
      return {
        ...contrato,
        adelantoRecurrenteCAC: contrato.adelantoRecurrenteCAC / 100,
        adelantoInicialNominal: contrato.adelantoInicialNominal ? contrato.adelantoInicialNominal / 100 : 0,
        vendedorId: vendedor ? { id: contrato.vendedorId, label: getLabel(vendedor) } : null,
        referenciadoId: referenciado ? { id: contrato.referenciadoId, label: getLabel(referenciado) } : null,
        refuerzo,
        estado: contrato.estado
      }
    }
    function mapCampanasToFormProps(contrato) {
      let campanasContrato = (campanas || []).filter(c => parseInt(c.contratoId) === parseInt(contrato.contratoId)).map(c => {
        let documento = (documentos || []).find(d => d.nombreTabla === 'Campanas' && d.refId === c.campanaId);

        if (documento) return ({ ...c, documento })
        else return ({ ...c, documento: null })
      })
      return campanasContrato.map(campana => {
        let tipo = tiposCampana?.find(t => parseInt(t.tipoCampanaId) === parseInt(campana.tipoCampanaId));
        return {
          ...campana,
          tipo: { id: tipo.tipoCampanaId, label: tipo.nombre },
          parametros: {
            porcentaje: campana.parametros.porcentaje * 100
          }
        }
      })
    }
    function mapSociosToFormProps(contrato) {
      let socios = (titularidades || [])?.filter(titularidad => titularidad.contratoId === contrato.contratoId);
      return socios?.map(socio => {
        let persona = personas?.find(p => p.personaId === socio.personaId);;
        return {
          socio: persona ? { id: socio.personaId, label: getLabel(persona) } : "",
          porcentaje: socio.partes,
          socioId: socio.personaId,
          titularPrincipal: socio.titularPrincipal,
          fechaAplicacionDesde: socio.fechaAplicacionDesde,
          fechaInicioVigencia: socio.fechaInicioVigencia,
          fechaAplicacionHasta: socio.fechaAplicacionHasta
        }
      });
    };
    const getNombrePersona = (personaId) => {
      let persona = personas?.find(p => p.personaId === personaId);
      if (persona) {
        return getLabel(persona);
      }
      return '-';
    };
    function InputFile(props) {
      return (
        <div
          id={props.docId + 'input-doc'}
          style={{
            position: "relative",
            width: '15%',
            height: '4vh',
          }}
        >
          <Button
            size="small"
            sx={{ height: '4vh', minWidth: 130, fontWeight: 'bold', }}
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "0",
            }}
            variant="contained"
          >
            Adjuntar <AttachFileIcon />
          </Button>
          <input
            style={{
              opacity: "0",
              position: "absolute",
              top: "0",
              left: "0",
              width: "20vh",
              height: '4vh',
              zIndex: "2",
            }}
            type="file"
            multiple={props.multiple}
            onChange={props.onChange}
            className="input-field"
            id={"file" + props.docId}
            value={""}
          />
        </div>
      )
    };
    const handleOpenUrl = (url) => {
      window.open(url, '_blank'); // Open the URL in a new tab
    };
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
      serie: false,
      editorId: false,
      editor: false,
      vendedorId: false,
      vendedor: false,
      adelantoInicialNominal: false,
      adelantoInicialCAC: false,
      adelantoRecurrenteNominal: false,
      adelantoRecurrenteCAC: false,
      aporteMinPersonalizadoMenNominal: false,
      aporteMinPersonalizadoMenCAC: false,
      perPrimaAdjudicacion: false,
      titularId: true,
      etapa: true,
      estado: true,
      clase: true,
      titular: true,
      fechaPerfeccionamiento: true,
      fechaFirma: true,
      mesRefuerzoSemestral1: true
    });
    let rows = (contratos || []);
    const EditarContratoForm = (props) => {
      const inf = (useSelector(state => state.contratos.infoContrato) || {});
      const detalles = {
        //claseContrato: clasesContratos?.find(x => parseInt(x.claseContratoId) === parseInt(inf?.contrato?.claseContratoId)),
        //contrato: inf?.contrato,
        historia: inf?.historia,
        //titularidades: inf?.titularidades // (titularidades || [])?.filter(x => parseInt(x.contratoId) === parseInt(contratoSeleccionado)), //inf?.titularidades
      };
      const [step, setStep] = useState(0)
      const [selectedTab, setSelectedTab] = useState(0);
      const [msjFooter, setMsjFooter] = useState([]);
      //A: el contratodefault cuando el usuario esta creando un nuevo contrato
      let contratoAux = { ...contratoParaEditar, ...detalles };
      const [contrato, setContrato] = useState({ ...contratoAux });
      let sociosAux = sociosParaEditar ? JSON.parse(JSON.stringify(sociosParaEditar || [])) : []
      const [socios, setSocios] = useState(JSON.parse(JSON.stringify(sociosAux || []))); //A: aca guardamos los socios, son una lista separada
      const [sociosOriginales, setSociosOriginales] = useState(JSON.parse(JSON.stringify(sociosAux || [])));
      const [sociosAEliminar, setSociosAEliminar] = useState([]); //A: aca guardamos los socios, son una lista separada
      let campanasAux = [...campanasParaEditar];
      const [campanasContrato, setCampanasContrato] = useState([...campanasAux])
      const [campanasCreacion, setCampanasCreacion] = useState({ campanaRefuerzo: false, campanaNoCuota: false })
      const claseContrato = clasesContratos?.find(cc => cc.claseContratoId === contrato?.claseContratoId);
      let fechaAplicacionDesde = new Date(contrato ? parseInt(contrato?.fechaAplicacionDesde) : null)
      const indiceActual = getIndiceAt(contrato ? parseInt(contrato.fechaAplicacionDesde) : new Date().valueOf, -2)
      let fechaCreacion = new Date(contrato ? parseInt(contrato.fechaCreacion) : null);
      const indiceCreacion = fechaCreacion.getMonth() >= MESES_LAG ?
        getIndiceAt(fechaCreacion.setMonth(fechaCreacion.getMonth() - MESES_LAG)) :
        getIndiceAt(fechaCreacion.setMonth(fechaCreacion.getMonth() + (12 - MESES_LAG)) && fechaCreacion.setFullYear(fechaCreacion.getFullYear() - 1));
      //Nueva parte
      const nominal2CAC = (nom, fecha = (step === 1 ? fechaCreacion : fechaAplicacionDesde)) => nom / getIndiceAt(fecha, -2)?.cac;
      const CAC2Nominal = (cac, fecha = (step === 1 ? fechaCreacion : fechaAplicacionDesde)) => cac * getIndiceAt(fecha, -2)?.cac;
      const handleChange = (property, value) => setContrato({ ...contrato, [property]: value });
      const [cuotaPactadaNominal, setCuotaPactadaNominal] = useState(0);

      const campanaDflt = {
        contratoId: parseInt(contrato.contratoId),
        tipo: '',
        fechaInicio: (new Date().setHours(0, 0, 0, 0)).valueOf(),
        fechaFinalizacion: (new Date().setHours(23, 59, 0, 0)).valueOf(),
        parametros: { porcentaje: 0 },
        creacion: false
      };
      const getMinCuotaNominal = () => {
        let valorOASum = claseContrato?.valorObjetoAhorroCAC;
        let prima = (1 - contrato.perPrimaAdjudicacion);
        let adelantoConBonif = nominal2CAC(contrato.adelantoInicialNominal * 100, contrato.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)
        let factorRefuerzo = (contrato.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
        let cuotaMin = CAC2Nominal(factorRefuerzo * ((valorOASum * prima) - adelantoConBonif), contrato.fechaAplicacionDesde) / 100;
        return cuotaMin
      };
      const getAdelantoRecurrenteNom = () => {
        let adelanto = cuotaPactadaNominal - getMinCuotaNominal();
        return adelanto < 0 ? 0 : adelanto;
      };
      const handleMouseDownInput = (event) => {
        event.preventDefault();
      };
      const handleDateChange = (newFecha) => {
        const historiaFecha = contrato?.historia
          .filter(objeto => (objeto.fecha || objeto.operacion.fecha) < newFecha)
          .sort((a, b) => (b.fecha || b.operacion.fecha) - (a.fecha || a.operacion.fecha))[0];
        const contratoFecha = historiaFecha?.contratoActual
        setContrato({
          ...contrato,
          claseContratoId: contratoFecha?.claseContratoId,
          refuerzo: contratoFecha?.mesRefuerzoSemestral1 !== null ? true : false,
          adelantoRecurrenteCAC: contratoFecha?.adelantoRecurrenteCAC / 100,
          perPrimaAdjudicacion: contratoFecha?.perPrimaAdjudicacion,
          estado: contratoFecha?.estado,
          fechaAplicacionDesde: new Date(newFecha).setHours(0, 0, 0, 0)
        });
        let titularidadesFecha = historiaFecha?.titularidadesActuales?.map(socio => {
          let persona = personas?.find(p => parseInt(p.personaId) === parseInt(socio.personaId));;
          return {
            socio: persona ? { id: socio.personaId, label: getLabel(persona) } : "",
            porcentaje: socio.partes,
            socioId: socio.personaId,
            titularPrincipal: socio.titularPrincipal,
            fechaAplicacionDesde: socio.fechaAplicacionDesde,
            fechaInicioVigencia: socio.fechaInicioVigencia,
            fechaAplicacionHasta: socio.fechaAplicacionHasta
          }
        })
        setSociosOriginales(JSON.parse(JSON.stringify([...titularidadesFecha] || [])))
        setSocios([...titularidadesFecha])
        setSociosAEliminar([]);
      };
      useEffect(() => {
        //Valor del bien
        let valorOASum = claseContrato?.valorObjetoAhorroCAC;
        let prima = (1 - contrato.perPrimaAdjudicacion);
        let adelantoConBonif = nominal2CAC(contrato.adelantoInicialNominal * 100, contrato.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)
        let factorRefuerzo = (contrato.refuerzo ? 350 : 300);
        let cuotaMin = CAC2Nominal(((valorOASum * prima) - adelantoConBonif) / factorRefuerzo, contrato.fechaAplicacionDesde) / 100;

        //const factor = (1 - contrato?.perPrimaAdjudicacion) * (contrato?.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
        //const valorOACAC = claseContrato?.valorObjetoAhorroCAC - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(contrato?.adelantoInicialNominal * 100, fechaAplicacionDesde);
        //const cuotaMin = CAC2Nominal(factor * valorOACAC, fechaAplicacionDesde) / 100
        setCuotaPactadaNominal((cuotaMin)?.toFixed(2));
      }, [contrato.perPrimaAdjudicacion, claseContrato, contrato.refuerzo]);
      useEffect(() => {
        //Valor del bien
        let valorOASum = claseContrato?.valorObjetoAhorroCAC;
        let prima = (1 - contrato.perPrimaAdjudicacion);
        let adelantoConBonif = nominal2CAC(contrato.adelantoInicialNominal * 100, contrato.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)
        let factorRefuerzo = (contrato.refuerzo ? 350 : 300);
        let cuotaCompleta = CAC2Nominal(((valorOASum * prima) - adelantoConBonif) / factorRefuerzo, contrato.fechaAplicacionDesde) / 100 + CAC2Nominal((contrato?.adelantoRecurrenteCAC), contrato?.fechaAplicacionDesde)


        setCuotaPactadaNominal((cuotaCompleta)?.toFixed(2));
      }, [contrato.fechaAplicacionDesde]);
      const getAdelantoRecurrenteCAC = (newContrato) => {
        let adelantoCAC = nominal2CAC((getAdelantoRecurrenteNom() * 100), (step === 1 ? fechaCreacion : parseInt(contrato?.fechaAplicacionDesde)));
        return parseFloat(adelantoCAC)
      }
      const getDropdownOptions = (allPersonas) => {
        let personasAsArray = (personas || []);
        if (!allPersonas) {
          personasAsArray = personasAsArray.filter(p => p.personaFisica);
        }
        return personasAsArray.map(p => ({ id: p.personaId, label: getLabel(p) }));
      }
      const getDropdownAhorristas = (allPersonas) => {
        let personasAhorristasIds = (rolesPersonasMap || [])?.filter(pr => pr.rolId === (roles || [])?.find(r => r.nombre === 'Ahorrista')?.rolId)?.map(pr => pr.personaId)
        let personasAhorristas = allPersonas?.filter(p => personasAhorristasIds?.includes(p.id))
        return personasAhorristas
      };
      const getDropdownVendedores = (allPersonas) => {
        let personasVendedoresIds = (rolesPersonasMap || [])?.filter(pr => pr.rolId === (roles || [])?.find(r => r.nombre === 'Ejecutivo de Cuentas')?.rolId ||
          pr.rolId === (roles || [])?.find(r => r.nombre === 'Vendedor Externo')?.rolId)?.map(pr => pr.personaId)
        let personasVendedores = allPersonas?.filter(p => personasVendedoresIds?.includes(p.id))
        return personasVendedores
      }
      const getOptionsClasesContratos = () => {
        return clasesContratos.map(cc => ({ id: cc.claseContratoId, label: cc.descripcion }))
      };
      const getDropdownTiposCampanas = () => {
        let tipos = tiposCampana?.map(t => ({ id: t.tipoCampanaId, label: t.nombre }))
        return contrato?.refuerzo ? tipos : tipos//?.filter(t => t.label !== 'Per Refuerzo Ahorro');
      };
      const filterOptions = createFilterOptions({ matchFrom: 'any', limit: 500, });
      const handleSubmit = () => {
        let estamosEditando = contratoParaEditar ? true : false;
        let newContrato = { ...contrato };
        delete newContrato.refuerzo;
        delete newContrato.historia;
        if (newContrato.vendedorId) newContrato.vendedorId = newContrato.vendedorId.id;
        if (newContrato.referenciadoId) newContrato.referenciadoId = newContrato.referenciadoId.id;
        let newSocios = socios?.filter(s => !(sociosOriginales?.find(so => so === s)))?.map(s => ({ contratoId: contrato?.contratoId, personaId: s.socio.id, partes: s.porcentaje, fechaAplicacionDesde: parseInt(contrato?.fechaAplicacionDesde), fechaInicioVigencia: step === 1 ? parseInt(contrato?.fechaCreacion) : parseInt(s.fechaInicioVigencia), titularPrincipal: s.titularPrincipal, fechaAplicacionHasta: null, eliminado: false }));
        let sociosEliminar = sociosAEliminar?.map(s => ({ contratoId: contrato?.contratoId, personaId: s.socio.id, partes: 0, fechaAplicacionDesde: parseInt(contrato?.fechaAplicacionDesde), fechaAplicacionHasta: parseInt(contrato?.fechaAplicacionDesde), fechaInicioVigencia: parseInt(s.fechaInicioVigencia), titularPrincipal: s.titularPrincipal, eliminado: true }))

        newContrato.adelantoInicialNominal = parseInt((newContrato.adelantoInicialNominal * 100).toFixed(0));
        newContrato.socios = newSocios;
        newContrato.sociosAEliminar = sociosEliminar
        newContrato.adelantoRecurrenteCAC = getAdelantoRecurrenteCAC();
        newContrato.mesRefuerzoSemestral1 = contrato?.refuerzo ? 0 : null
        newContrato.mesRefuerzoSemestral2 = contrato?.refuerzo ? 6 : null
        // MANEJO CAMAPANAS
        let newCampanasCreacion = []
        let newCampanasContrato = campanasContrato?.map(campana => ({ ...campana, tipoCampanaId: campana.tipo.id, parametros: { porcentaje: campana.parametros.porcentaje / 100 } }));
        if (step === 1) {
          let campanasFiltradas = newCampanasContrato?.filter(c => c.creacion)

          if (campanasFiltradas) {
            let refuerzo = campanasFiltradas?.find(c => (c.tipoCampanaId) === tiposCampana?.find(t => t.nombre === 'Per Refuerzo Ahorro')?.tipoCampanaId)
            let noCuota = campanasFiltradas?.find(c => (c.tipoCampanaId) === tiposCampana?.find(t => t.nombre === 'Per Cuota Ahorro')?.tipoCampanaId)
            let noAdelanto = campanasFiltradas?.find(c => (c.tipoCampanaId) === tiposCampana?.find(t => t.nombre === 'Per Adelanto Prepactado')?.tipoCampanaId)
            let campanaPAE = campanasFiltradas?.find(c => (c.tipoCampanaId) === tiposCampana?.find(t => t.nombre === 'Per Bonificación Cuota PAE')?.tipoCampanaId)

            const campanaRefuerzoDflt = {
              contratoId: contrato?.contratoId,
              tipoCampanaId: tiposCampana?.find(t => t.nombre === 'Per Refuerzo Ahorro')?.tipoCampanaId,
              fechaInicio: new Date(parseInt(contrato?.fechaCreacion)).setHours(0, 0, 0, 0),
              fechaFinalizacion: (() => {
                const fecha = new Date(parseInt(contrato?.fechaCreacion));
                fecha.setMonth(fecha.getMonth() + 4);
                fecha.setMonth(fecha.getMonth() + 1, 0);
                fecha.setHours(23, 59, 0, 0);
                return fecha.valueOf();
              })(),
              parametros: { porcentaje: 0 },
              creacion: true
            }
            const campanaNoCuotaDflt = {
              contratoId: contrato?.contratoId,
              tipoCampanaId: tiposCampana?.find(t => t.nombre === 'Per Cuota Ahorro')?.tipoCampanaId,
              fechaInicio: (() => {
                const fecha = new Date(parseInt(contrato?.fechaCreacion));
                fecha.setDate(1);
                fecha.setMonth(fecha.getMonth() + 1);
                fecha.setHours(0, 0, 0, 0);
                return fecha.valueOf();
              })(),
              fechaFinalizacion:
                (() => {
                  const fecha = new Date(parseInt(contrato?.fechaCreacion));
                  fecha.setMonth(fecha.getMonth() + 1);
                  fecha.setMonth(fecha.getMonth() + 1, 0);
                  fecha.setHours(23, 59, 0, 0);
                  return fecha.valueOf();
                })(),

              parametros: { porcentaje: 0 },
              creacion: true
            };
            const campanaNoAdelantoDflt = {
              contratoId: contrato?.contratoId,
              tipoCampanaId: tiposCampana?.find(t => t.nombre === 'Per Adelanto Prepactado')?.tipoCampanaId,
              fechaInicio: (() => {
                const fecha = new Date(parseInt(contrato?.fechaCreacion));
                fecha.setDate(1);
                fecha.setMonth(fecha.getMonth() + 1);
                fecha.setHours(0, 0, 0, 0);
                return fecha.valueOf();
              })(),
              fechaFinalizacion: (() => {
                const fecha = new Date(parseInt(contrato?.fechaCreacion));
                fecha.setMonth(fecha.getMonth() + 1);
                fecha.setMonth(fecha.getMonth() + 1, 0);
                fecha.setHours(23, 59, 0, 0);
                return fecha.valueOf();
              })(),
              parametros: { porcentaje: 0 },
              creacion: true
            };
            const campanaPAEParametros = {
              contratoId: contrato?.contratoId,
              tipoCampanaId: tiposCampana?.find(t => t.nombre === 'Per Bonificación Cuota PAE')?.tipoCampanaId,
              fechaInicio: (() => {
                const fecha = new Date(parseInt(contrato?.fechaCreacion));
                fecha.setDate(1);
                fecha.setMonth(fecha.getMonth() + (campanasCreacion?.campanaNoCuota ? 2 : 1));
                fecha.setHours(0, 0, 0, 0);
                return fecha.valueOf();
              })(),
              fechaFinalizacion: (() => {
                const fecha = new Date(parseInt(campanasCreacion?.campanaPAE?.fechaFinalizacion));
                fecha.setHours(23, 59, 0, 0);
                return fecha.valueOf();
              })(),
              parametros: { porcentaje: campanasCreacion?.campanaPAE?.porcentaje / 100 },
              creacion: true
            };
            if (campanasCreacion?.campanaRefuerzo) refuerzo ? newCampanasContrato = newCampanasContrato?.map(c => c.campanaId === refuerzo.campanaId ? ({ ...campanaRefuerzoDflt, campanaId: refuerzo?.campanaId }) : c) : newCampanasContrato.push({ ...campanaRefuerzoDflt })
            if (!campanasCreacion?.campanaRefuerzo && refuerzo) newCampanasContrato = newCampanasContrato?.filter(c => !(c.campanaId === refuerzo.campanaId));

            if (campanasCreacion?.campanaNoCuota) noCuota ? newCampanasContrato = newCampanasContrato?.map(c => c.campanaId === noCuota.campanaId ? ({ ...campanaNoCuotaDflt, campanaId: noCuota?.campanaId }) : c.campanaId === noAdelanto.campanaId ? ({ ...campanaNoAdelantoDflt, campanaId: noAdelanto?.campanaId }) : c) : (newCampanasContrato.push({ ...campanaNoAdelantoDflt }, { ...campanaNoCuotaDflt }))
            if (!campanasCreacion?.campanaNoCuota && noCuota) newCampanasContrato = newCampanasContrato?.filter(c => !(c.campanaId === noCuota.campanaId || c.campanaId === noAdelanto.campanaId));

            if (campanasCreacion?.campanaPAE.campanaPAE) campanaPAE ? newCampanasContrato = newCampanasContrato?.map(c => c.campanaId === campanaPAE.campanaId ? ({ ...campanaPAEParametros, campanaId: campanaPAE?.campanaId }) : c) : newCampanasContrato.push({ ...campanaPAEParametros })
            if (!campanasCreacion?.campanaPAE.campanaPAE && campanaPAE) newCampanasContrato = newCampanasContrato?.filter(c => !(c.campanaId === campanaPAE.campanaId));
          }
        };

        let newContratoDocumentosAux = new FormData();
        newCampanasContrato?.forEach(c => {
          if (c.documento) newContratoDocumentosAux.append('files', c.documento);
        });
        newCampanasContrato.forEach(n => delete n.tipo)
        newContrato.campanas = newCampanasContrato.map(c => ({ ...c, documento: c.documento ? c.documento.name : null }));
        newContratoDocumentosAux.append("contrato", JSON.stringify(newContrato));
        if (estamosEditando) {
          try {
            const response = fetch((process.env.REACT_APP_BACKEND_URL + '/contratos'), {
              method: 'PUT',
              body: newContratoDocumentosAux,
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });
            if (response) {

              // Procesa la respuesta del servidor aquí
              dispatch(getContratosData())
              setShowEditarContratoForm(false)
            } else {
              console.error('Error al subir el archivo');
              dispatch(getContratosData())
              setShowEditarContratoForm(false)
            }
          } catch (error) {
            console.error('Error al subir el archivo:', error);
            dispatch(getContratosData())
            setShowEditarContratoForm(false)
          }
          // dispatch(editContrato(newContrato)).catch(console.error)
          // setModalConfirmacion(false)
          // setShowEditarContratoForm(false)
        };
      };
      const handelSocioChange = (socio, index) => {
        let newSocios = [...socios];
        if (newSocios[index] === null || newSocios[index] === undefined) newSocios[index] = {};
        newSocios[index].socio = socio;
        setSocios(newSocios);
      };
      const removeSocio = (index) => { setSocios([...socios.filter((x, i) => i !== index)]); setSociosAEliminar([...socios.filter((x, i) => i === index)]) };
      const removeCampana = (index) => setCampanasContrato([...campanasContrato.filter((x, i) => i !== index)]);
      const ClaseContratoSelector = (props) => {
        return (<FormControl fullWidth >
          <InputLabel id="seleccion-clase-contrato">Clase Contrato</InputLabel>
          <Select className='noBorder' labelId="seleccion-clase-contrato" value={contrato.claseContratoId} label="Clase Contrato" onChange={e => handleChange('claseContratoId', e.target.value)}>
            {clasesContratos?.map(x => <MenuItem key={'clase-contrato' + x.claseContratoId} value={x.claseContratoId}>{x.codigo}</MenuItem>)}
          </Select>
        </FormControl>)
      };
      const [modalConfirmacion, setModalConfirmacion] = useState(false);
      const openModalConfirmacion = () => setModalConfirmacion(true);
      const closeModalConfirmacion = () => setModalConfirmacion(false);
      const ModalConfirmacion = (props) => {
        return (
          <Dialog onClose={closeModalConfirmacion} open={modalConfirmacion} maxWidth="sm" fullWidth>
            <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Confirmar</DialogTitle>
            <DialogContent dividers>
              {fetching > 0 ?
                <Grid direction={'column'} sx={{
                  display: 'flex',
                  justifyContent: 'center', // Centra horizontalmente
                  alignItems: 'center', // Centra verticalmente
                  minHeight: '20vh', // Asegura que el contenedor ocupe toda la altura de la pantalla
                }}>
                  <Typography children={'Eliminando contrato...'} />
                  <ClipLoader
                    color={theme.palette.success.main}
                    loading={true}
                    size={30}
                    data-testid="loader"
                  />
                </Grid>
                :
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography>
                      ¿Seguro quiere editar el contrato? Esta acción no podrá deshacerse.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>
                      Ha seleccionado: {claseContrato?.descripcion}.
                    </Typography>
                    <Typography>
                      Cuota prepactada: ${cuotaPactadaNominal}.
                    </Typography>
                    <Typography>
                      Adelanto Recurrente: ${getAdelantoRecurrenteNom()?.toFixed(2)}.
                    </Typography>
                    <Typography>
                      Prima: {contrato?.perPrimaAdjudicacion?.toFixed(2)} %.
                    </Typography>
                    <Typography>
                      {socios?.length + (socios?.length === 1 ? ' Socio titular seleccionado.' : ' Socios titulares seleccionados.')}
                    </Typography>
                  </Grid>
                </Grid>}
            </DialogContent>
            <DialogActions style={{ marginTop: '10px', marginLeft: '5px' }}>
              <Button
                disabled={fetching > 0}
                variant="outlined"
                sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold" }}
                onClick={closeModalConfirmacion}>
                {'Cancelar'}
              </Button>
              <Button
                disabled={fetching > 0}
                variant="contained"
                onClick={handleSubmit}
                sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold", color: "white" }}>
                {'Aceptar'}
              </Button>
            </DialogActions>
          </Dialog>
        );
      };
      const handleValidation = () => {
        setMsjFooter([]);
        let huboError = false
        if (Math.abs(socios.reduce((p, x) => p + parseFloat(x.porcentaje), 0) - 100) > 0.0001) {
          huboError = true
          setMsjFooter([...msjFooter, `Los porcentajes de titularidad deben sumar 100%.`])
          return;
        };
        if (cuotaPactadaNominal < (getMinCuotaNominal() - 0.05)) {
          let error = `La cuota prepactada no podrá ser menor a $${getMinCuotaNominal()?.toFixed(2)}`
          huboError = true
          setMsjFooter(msjFooter?.includes(error) ? [...msjFooter] : [...msjFooter, error])
          return;
        };
        if (campanasContrato.some(c => c.parametros.porcentaje > 100)) {
          let error = `El porcentaje de cada campaña tiene como valor máximo 100%.`
          huboError = true
          setMsjFooter(msjFooter?.includes(error) ? [...msjFooter] : [...msjFooter, error])
          return;
        };
        if (!socios?.find(s => s.titularPrincipal === true)) {
          let error = `Debe seleccionar un titular principal.`
          setMsjFooter(msjFooter?.includes(error) ? [...msjFooter] : [...msjFooter, error])
          huboError = true
          return
        };
        if (socios?.filter(s => s.titularPrincipal === true)?.length > 1) {
          let error = `Debe seleccionar solo un titular principal.`
          setMsjFooter(msjFooter?.includes(error) ? [...msjFooter] : [...msjFooter, error])
          huboError = true
          return
        };
        let campanasConMismoDocumento = [];
        for (let i = 0; i < campanasContrato.length; i++) {
          for (let j = i + 1; j < campanasContrato.length; j++) {
            if (campanasContrato[i].documento && campanasContrato[j].documento &&
                campanasContrato[i].documento.name === campanasContrato[j].documento.name && campanasContrato[j].documento.name) {
              campanasConMismoDocumento.push(campanasContrato[i], campanasContrato[j]);
            }
          }
        };
        if (campanasConMismoDocumento.length > 0) {
          let error = `Los archivos adjuntos de las campañas no pueden tener el mismo nombre.`;
          setMsjFooter(msjFooter?.includes(error) ? [...msjFooter] : [...msjFooter, error]);
          huboError = true;
          return;
        };
        if (huboError) {
          return
        };
        openModalConfirmacion()
      };
      //Campanas functions
      const getCuotaPAE = () => {
        let valorOASum = claseContrato?.valorObjetoAhorroCAC;
        let cuotaPAE = getConversionesCAC((valorOASum / claseContrato?.nCuotas), indiceActual, claseContrato, contrato.fechaAplicacionDesde);
        return (cuotaPAE.nominal)
      };
      const getImporteCampana = (campana) => {
        const getPrimaCuota = () => {
          let valorOASum = claseContrato?.valorObjetoAhorroCAC;
          let prima = CAC2Nominal((contrato.perPrimaAdjudicacion * valorOASum) / 24, (step === 1 ? contrato.fechaCreacion : contrato.fechaAplicacionDesde));
          return prima;
        };
        const aporteMinimoAdjudicacion = () => {
          const factor = (contrato.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
          let valorOASum = claseContrato?.valorObjetoAhorroCAC;
          const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(contrato.adelantoInicialNominal * 100, contrato.fechaCreacion);
          const cuotaPrima = contrato.perPrimaAdjudicacion * valorOASum / 24;
          return CAC2Nominal(factor * valorOACAC + cuotaPrima, (step === 1 ? contrato.fechaCreacion : contrato.fechaAplicacionDesde));
        };
        const aporteMinimoTenencia = () => {
          const factor = (contrato.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
          let valorOASum = claseContrato?.valorObjetoAhorroCAC;
          const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(contrato.adelantoInicialNominal * 100, contrato.fechaCreacion);
          const perCuotaPosesion = contrato.refuerzo ? 1.7 : 1.6;
          return CAC2Nominal(factor * valorOACAC * perCuotaPosesion, (step === 1 ? contrato.fechaCreacion : contrato.fechaAplicacionDesde));
        };
        const getBonificacionInicial = (per) => {
          const bonifIniCAC = nominal2CAC(contrato?.adelantoInicialNominal * 100 * per, contrato.fechaCreacion);
          return CAC2Nominal(bonifIniCAC, (step === 1 ? contrato.fechaCreacion : contrato.fechaCreacion));
        };

        const bonificacionMensual = (per) => {
          const cuota = nominal2CAC(cuotaPactadaNominal * 100, (step === 1 ? contrato.fechaCreacion : contrato.fechaAplicacionDesde));
          const factor = (1 - contrato.perPrimaAdjudicacion) * (contrato.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
          let valorOASum = claseContrato?.valorObjetoAhorroCAC;
          const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(contrato.adelantoInicialNominal * 100, contrato.fechaCreacion);
          return CAC2Nominal((cuota - factor * valorOACAC) * per, (step === 1 ? contrato.fechaCreacion : contrato.fechaAplicacionDesde));
        };
        const getCupon = () => {
          const mesCorriente = new Date().getMonth()
          const refuerzoCuotaMin = (contrato.refuerzo && [0, 6].includes(mesCorriente) ? getMinCuotaNominal() : 0);
          const refuerzoAdelanto = (contrato.refuerzo && [0, 6].includes(mesCorriente) ? getAdelantoRecurrenteNom() : 0);
          const importeCupon = cuotaPactadaNominal + refuerzoAdelanto + refuerzoCuotaMin
          return importeCupon;
        };
        let importe = 0
        switch (campana.tipo.label) {
          case 'Per Cuota Ahorro':
            importe = ((getMinCuotaNominal() * (parseFloat(campana.parametros.porcentaje) / 100)))?.toFixed(2);
            break;
          case 'Per Refuerzo Ahorro':
            importe = (cuotaPactadaNominal * (parseFloat(campana.parametros.porcentaje) / 100))?.toFixed(2);
            break;
          case 'Per Cuota Prima':
            importe = (getPrimaCuota() * (parseFloat(campana.parametros.porcentaje) / 100))?.toFixed(2);
            break;
          case 'Per Cuota Licitación':
            importe = (aporteMinimoTenencia() * (parseFloat(campana.parametros.porcentaje) / 100))?.toFixed(2);
            break;
          case 'Per Cuota Posesión':
            importe = (aporteMinimoTenencia() * (parseFloat(campana.parametros.porcentaje) / 100))?.toFixed(2);
            break;
          case 'Per Adelanto Prepactado':
            importe = getAdelantoRecurrenteNom() * (parseFloat(campana.parametros.porcentaje) / 100);
            break;
          case 'Bonificación Adelanto Prepactado':
            importe = bonificacionMensual(parseFloat(campana.parametros.porcentaje) / 100);
            break;
          case 'Bonificación Adelanto Inicial':
            importe = getBonificacionInicial(parseFloat(campana.parametros.porcentaje) / 100);
            break;
          case 'Per Bonificación Cuota PAE':
            importe = (getCuotaPAE() * parseFloat(campana.parametros.porcentaje) / 100) / 100;
            break;
          case 'Per Cupon':
            importe = (getCupon() * parseFloat(campana.parametros.porcentaje)) / 100;
            break;
          default:
            importe = 'N/A'
            break;
        };
        return importe
      };
      const FechaFinAction = (props) => {
        const [anchorEl, setAnchorEl] = useState(null);

        const handlePopoverOpen = (event) => {
          setAnchorEl(event.currentTarget)
        };

        const handlePopoverClose = () => {
          setAnchorEl(null)
        };
        const { label, key, Icon } = props;
        const open = Boolean(anchorEl);
        return (
          <Fragment key={key + label}>
            <Icon aria-owns={open ? label : undefined}
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}> </Icon>
            <Popover
              id={label}
              sx={{
                pointerEvents: 'none',
              }}
              open={open}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              onClose={handlePopoverClose}
              disableRestoreFocus
            >
              <Typography sx={{ p: 1 }}>{label}</Typography>
            </Popover>
          </Fragment>
        )
      };
      const getHelperTextCampana = (tipo) => {
        let descripcion = tiposCampana?.find(tc => parseInt(tipo.id) === parseInt(tc.tipoCampanaId))?.descripcion
        return descripcion
      }
      //Select Form
      const SelectForm = () => {
        const handleCreacion = () => {
          const historiaFecha = contrato?.historia
            .filter(objeto => (objeto.fecha || objeto.operacion.fecha) <= parseInt(contratoAux.fechaCreacion))
            .sort((a, b) => (b.fecha || b.operacion.fecha) - (a.fecha || a.operacion.fecha))[0];
          const contratoFecha = contrato?.historia?.find(h => h.operacion?.tipo === 'Creación')?.contratoActual
          setContrato({
            ...contrato,
            adelantoInicialNominal: contratoFecha.adelantoInicialNominal ? parseFloat(contratoFecha.adelantoInicialNominal) / 100 : 0,
            claseContratoId: contratoFecha?.claseContratoId,
            refuerzo: contratoFecha?.mesRefuerzoSemestral1 !== null ? true : false,
            adelantoRecurrenteCAC: contratoFecha?.adelantoRecurrenteCAC / 100,
            perPrimaAdjudicacion: contratoFecha?.perPrimaAdjudicacion,
            estado: contratoFecha?.estado,
            fechaAplicacionDesde: parseInt(contratoFecha.fechaCreacion),
            fechaCreacion: parseInt(contratoFecha.fechaCreacion)
          });
          let titularidadesFecha = historiaFecha?.titularidadesActuales?.map(t => {
            let persona = personas?.find(p => p.personaId === t.personaId);
            return {
              socio: persona ? { id: t.personaId, label: getLabel(persona) } : "",
              porcentaje: t.partes,
              socioId: t.personaId,
              titularPrincipal: t.titularPrincipal,
              fechaAplicacionDesde: t.fechaAplicacionDesde,
              fechaInicioVigencia: t.fechaInicioVigencia,
              fechaAplicacionHasta: null
            };
          })
          setSociosOriginales(JSON.parse(JSON.stringify([...titularidadesFecha] || [])))
          setSocios([...titularidadesFecha])
          setSociosAEliminar([]);
          setSelectedTab(0)
          setStep(1);
          let campanasFiltradas = campanasContrato?.filter(c => c.creacion)
          if (campanasFiltradas) {
            let refuerzo = campanasFiltradas?.find(c => (c.tipo.label) === 'Per Refuerzo Ahorro')
            let noCuota = campanasFiltradas?.find(c => (c.tipo.label) === 'Per Cuota Ahorro')
            let campanaPAE = campanasFiltradas?.find(c => (c.tipo.label) === 'Per Bonificación Cuota PAE')
            setCampanasCreacion({
              campanaRefuerzo: refuerzo ? true : false,
              campanaNoCuota: noCuota ? true : false,
              campanaPAE: campanaPAE ? {
                campanaPAE: true,
                porcentaje: campanaPAE.parametros?.porcentaje,
                fechaFinalizacion: campanaPAE?.fechaFinalizacion
              } :
                {
                  campanaPAE: false,
                  porcentaje: 20,
                  fechaFinalizacion: (() => {
                    const fecha = new Date(parseInt(contratoAux.fechaCreacion));
                    fecha.setMonth(fecha.getMonth() + (noCuota ? 4 : 3));
                    fecha.setMonth(fecha.getMonth() + 1, 0);
                    fecha.setHours(23, 59, 0, 0);
                    return fecha.valueOf();
                  })(),
                }
            });
          }
        };
        const handleActualizacion = () => {
          contratoAux = { ...contratoAux, fechaAplicacionDesde: new Date().valueOf() }
          setContrato({ ...contratoAux })
          setStep(2);
        };
        const handleCambioTipologia = () => {
          contratoAux = { ...contratoAux, fechaAplicacionDesde: new Date().valueOf() }
          setContrato({ ...contratoAux })
          setStep(3);
        };
        return (
          <>
            <Box>
              <Grid conteiner sx={{ display: "flex", justifyContent: "center", alingItems: "strech" }} direction={'row'}>
                <Button variant="outlined" sx={{ margin: 'auto', fontWeight: "bold", marginRight: '0.5rem' }} onClick={() => handleCreacion()}>{"Parámetros de creación"}</Button>
                <Button variant="outlined" sx={{ margin: 'auto', fontWeight: "bold", marginLeft: '0.5rem' }} onClick={() => handleActualizacion()}>{"Parámetros actuales"}</Button>
              </Grid>
              {/* <Grid conteiner sx={{ display: "flex", justifyContent: "center", alingItems: "strech" }} direction={'row'}>
                <Button variant="outlined" sx={{  fontWeight: "bold", marginTop: '0.5rem' }} onClick={() => handleCambioTipologia()}>{"Cambio Tipología"}</Button>
                </Grid> */}
            </Box>
          </>
        )
      };
      const CambioTipologiaForm = () => {
        const ultimaHistoria = _.last(contratoAux?.historia)
        const estadoActual = ultimaHistoria?.estado
        const claseContrato = clasesContratos?.find(cc => cc.claseContratoId === contratoAux?.claseContratoId);
        const [cuotaPactadaNominal, setCuotaPactadaNominal] = useState(0);
        const nuevaClaseContrato = clasesContratos?.find(cc => cc.claseContratoId === contrato?.claseContratoId);
        const nCuotas = contrato.refuerzo ? nuevaClaseContrato.nCuotas : 300;
        const apoMinAhorro = ((claseContrato.valorObjetoAhorroCAC) - (estadoActual?.adelantoInicialAcumCAC + estadoActual?.adelantoInicialBonifAcumCAC)) / (contratoAux?.refuerzo ? 350 : 300);
        const nuevoApoMinAhorro = ((nuevaClaseContrato.valorObjetoAhorroCAC) - (estadoActual?.adelantoInicialAcumCAC + estadoActual?.adelantoInicialBonifAcumCAC)) / nCuotas;
        const apoMinTotales = estadoActual?.cuotaEsperaAcumCAC + estadoActual?.refuerzoSemestralCuotaEsperaAcumCAC;
        const hayPrima = contrato.perPrimaAdjudicacion > 0;
        const pasaATopologiaMenor = nuevaClaseContrato?.claseContratoId >= claseContrato?.claseContratoId;
        const adelPrepactados = estadoActual?.adelantoRecurrenteAcumCAC + estadoActual?.refuerzoSemestralAdelantoRecurrenteAcumCAC;
        const adelPrepactadosBonif = (estadoActual?.adelantoRecurrenteBonifAcumCAC + estadoActual?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC);
        const nuevoAdelPrepactadoBonificable = (hayPrima ? (0) : (adelPrepactados)) / (pasaATopologiaMenor ? (2) : (1))
        const nuevoAdelPrepactadosBonif = (hayPrima ? (0) : adelPrepactadosBonif) / (pasaATopologiaMenor ? (2) : (1))

        const nuevoAdelEspontaneoBonificable = (hayPrima ? (0) : (estadoActual?.adelantoEspontaneoAcumCAC));
        const nuevoAdelEspontaneosBonif = nuevoAdelEspontaneoBonificable * 0.05;

        const nuevoTotalAdelBonificables = nuevoAdelEspontaneoBonificable + nuevoAdelPrepactadoBonificable;

        const totalAdelantos = estadoActual?.adelantoEspontaneoAcumCAC + adelPrepactados;
        const nuevaPrimaPendiente = (hayPrima ? contrato.perPrimaAdjudicacion * nuevaClaseContrato.valorObjetoAhorroCAC - totalAdelantos : 0);
        const aportesTotales = apoMinTotales + totalAdelantos;
        const qAportesMin = apoMinTotales / apoMinAhorro;
        const apoMinProm = aportesTotales / qAportesMin;
        const nuevoQAportesMin = apoMinTotales / nuevoApoMinAhorro;
        const nuevoApoMinProm = aportesTotales / nuevoQAportesMin;
        const valorContratoCAC = estadoActual?.adelantoInicialAcumCAC + estadoActual?.adelantoInicialBonifAcumCAC + estadoActual?.ofertaLicitatoriaAcumCAC
          + estadoActual?.ofertaLicitatoriaBonifAcumCAC + estadoActual?.cuotaEsperaAcumCAC + estadoActual?.cuotaEsperaBonifAcumCAC
          + estadoActual?.primaAcumCAC + estadoActual?.cuotaPrimaBonifAcumCAC + estadoActual?.cuotaPosesionAcumCAC
          + estadoActual?.adelantoRecurrenteAcumCAC + estadoActual?.adelantoRecurrenteBonifAcumCAC + estadoActual?.adelantoEspontaneoAcumCAC
          + estadoActual?.adelantoEspontaneoBonifAcumCAC + estadoActual?.refuerzoSemestralCuotaEsperaAcumCAC + estadoActual?.refuerzoSemestralCuotaEsperaBonifAcumCAC
          + estadoActual?.refuerzoSemestralAdelantoRecurrenteAcumCAC + estadoActual?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC;
        const nuevoValorContratoCAC = estadoActual?.adelantoInicialAcumCAC + estadoActual?.adelantoInicialBonifAcumCAC + estadoActual?.ofertaLicitatoriaAcumCAC
          + estadoActual?.ofertaLicitatoriaBonifAcumCAC + estadoActual?.cuotaEsperaAcumCAC + estadoActual?.cuotaEsperaBonifAcumCAC
          + estadoActual?.primaAcumCAC + estadoActual?.cuotaPrimaBonifAcumCAC + estadoActual?.cuotaPosesionAcumCAC
          + estadoActual?.adelantoRecurrenteAcumCAC + nuevoAdelPrepactadosBonif + estadoActual?.adelantoEspontaneoAcumCAC
          + nuevoAdelEspontaneosBonif + estadoActual?.refuerzoSemestralCuotaEsperaAcumCAC + estadoActual?.refuerzoSemestralCuotaEsperaBonifAcumCAC
          + estadoActual?.refuerzoSemestralAdelantoRecurrenteAcumCAC;
        const nuevoCapitalLicitatorio = estadoActual?.adelantoInicialAcumCAC + estadoActual?.adelantoInicialBonifAcumCAC + totalAdelantos + nuevoAdelEspontaneosBonif + nuevoAdelPrepactadosBonif;
        const nuevoPuntosPagoTiempoYForma = Math.min(estadoActual?.puntosPagoTiempoYForma, nuevoQAportesMin)
        const nuevoPuntosPorAdelantoIni = (estadoActual?.adelantoInicialBonifAcumCAC + estadoActual?.adelantoInicialAcumCAC) * 10 / (nuevoApoMinAhorro)
        const nuevoPuntosPorAdelantosEspontaneos = (estadoActual?.adelantoEspontaneoAcumCAC + nuevoAdelEspontaneosBonif) * 2 / (nuevoApoMinAhorro)
        const nuevoPuntosPorAdelantosPrepactados = (adelPrepactados + nuevoAdelPrepactadosBonif) * 4 / (nuevoApoMinAhorro)
        const nuevoPuntosPorAdelantos = nuevoPuntosPorAdelantoIni + nuevoPuntosPorAdelantosEspontaneos + nuevoPuntosPorAdelantosPrepactados
        const nuevoPuntosTotales = estadoActual?.puntosPorReferidos + nuevoPuntosPorAdelantos + nuevoPuntosPagoTiempoYForma
        useEffect(() => {
          //Valor del bien
          let valorOASum = nuevaClaseContrato?.valorObjetoAhorroCAC;
          let prima = (1 - contrato.perPrimaAdjudicacion);
          let adelantoConBonif = nominal2CAC(contrato.adelantoInicialNominal * 100, contrato.fechaCreacion) * (1 + nuevaClaseContrato?.perBonificiacionAdelantoInicial)
          let factorRefuerzo = (contrato.refuerzo ? 350 : 300);
          let cuotaCompleta = CAC2Nominal(((valorOASum * prima) - adelantoConBonif) / factorRefuerzo, contrato.fechaAplicacionDesde) / 100;


          setCuotaPactadaNominal((cuotaCompleta)?.toFixed(2));
        }, [contrato]);
        const NuevaClaseContratoSelector = (props) => {
          return (<FormControl fullWidth >
            <Select sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              width: "100%",
            }} labelId="seleccion-clase-contrato" value={contrato.claseContratoId} onChange={e => handleChange('claseContratoId', e.target.value)}>
              {clasesContratos?.filter(cc=> cc.principal)?.map(x => <MenuItem key={'clase-contrato' + x.claseContratoId} value={x.claseContratoId}>{x.codigo}</MenuItem>)}
            </Select>
          </FormControl>)
        };
        const NuevoRefuerzoSelector = (props) => {
          return (<FormControl fullWidth >
            <Select sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              width: "100%",
            }} labelId="seleccion-clase-contrato" value={contrato.refuerzo} onChange={e => handleChange('refuerzo', e.target.value)}>
              {[true, false].map((x, i) => <MenuItem key={'clase-contrato-refuerzo' + i} value={x}>{x ? 'Semestral' : 'Prorrateado'}</MenuItem>)}
            </Select>
          </FormControl>)
        };

        const getMinCuotaNominal = () => {
          let valorOASum = nuevaClaseContrato?.valorObjetoAhorroCAC;
          let prima = (1 - contrato.perPrimaAdjudicacion);
          let adelantoConBonif = nominal2CAC(contrato.adelantoInicialNominal * 100, contrato.fechaCreacion) * (1 + nuevaClaseContrato?.perBonificiacionAdelantoInicial)
          let factorRefuerzo = (contrato.refuerzo ? 1.0 : 7.0 / 6.0) / nuevaClaseContrato?.nCuotas;
          let cuotaMin = CAC2Nominal(factorRefuerzo * ((valorOASum * prima) - adelantoConBonif), contrato.fechaAplicacionDesde) / 100;
          return cuotaMin
        };
        const getAdelantoRecurrenteNom = () => {
          let adelanto = cuotaPactadaNominal - getMinCuotaNominal();
          return adelanto < 0 ? 0 : adelanto;
        };
        const getAdelantoRecurrenteCAC = (newContrato) => {
          let adelantoCAC = nominal2CAC((getAdelantoRecurrenteNom() * 100), (step === 1 ? fechaCreacion : parseInt(contrato?.fechaAplicacionDesde)));
          return parseFloat(adelantoCAC)
        };
        return (<Box minHeight='100%' sx={{ minWidth: '50em' }}>
          <Box>
            <FormContainer defaultValues={{ ...contrato }} onSuccess={handleSubmit}>
              <Grid container direction={'row'} spacing={2}>
                <Grid item xs={12}>
                  <Grid container sx={{ paddingRight: '0.5em' }} fullwidth alignItems={'center'}>
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} color={theme.palette.success.main} children={' Datos calculados:'} />
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Origen'} />
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Destino'} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Tipología" />} />
                    <Grid xs={4} children={claseContrato?.codigo} />
                    <Grid xs={4} children={<NuevaClaseContratoSelector />} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Objetivo Ahorro" />} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(CAC2Nominal(claseContrato.valorObjetoAhorroCAC) / 100)}`} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(CAC2Nominal(nuevaClaseContrato.valorObjetoAhorroCAC) / 100)}`} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children=" Per Prima Adjudicación" />} />
                    <Grid xs={4} children={`${contratoAux.perPrimaAdjudicacion * 100}%`} />
                    <Grid xs={4} children={<Slider value={contrato?.perPrimaAdjudicacion} onChange={e => handleChange('perPrimaAdjudicacion', e.target.value)} valueLabelDisplay="auto" step={0.05} marks min={0} max={0.2} />} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children=" Prima Adjudicación" />} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(CAC2Nominal((contratoAux.perPrimaAdjudicacion * claseContrato.valorObjetoAhorroCAC)) / 100)}`} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(CAC2Nominal((contrato.perPrimaAdjudicacion * nuevaClaseContrato.valorObjetoAhorroCAC)) / 100)}`} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children=" Refuerzo" />} />
                    <Grid xs={4} children={contratoAux.refuerzo ? 'Semestral' : 'Prorrateado'} />
                    <Grid xs={4} children={<NuevoRefuerzoSelector />} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children=" Adel. Inicial" />} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(contratoAux.adelantoInicialNominal / 100)}`} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(contratoAux.adelantoInicialNominal / 100)}`} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children=" Bonif. Adel. Inicial" />} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(CAC2Nominal(estadoActual.adelantoInicialBonifAcumCAC) / 100)}`} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(CAC2Nominal(estadoActual.adelantoInicialBonifAcumCAC) / 100)}`} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children=" Aporte Min Ahorro" />} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(CAC2Nominal(apoMinAhorro) / 100)}`} />
                    <Grid xs={4} children={`$ ${moneyFormatMinuta(CAC2Nominal(nuevoApoMinAhorro) / 100)}`} />
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container sx={{ paddingRight: '0.5em' }} fullwidth alignItems={'center'}>
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} color={theme.palette.success.main} children={' Avance:'} />
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Origen'} />
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Destino'} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Aportes Mínimos (incluye refuerzos)" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(apoMinTotales) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(apoMinTotales, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(apoMinTotales) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(apoMinTotales, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Q Aportes Mínimos " />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'center'}>
                      <Grid xs={12} children={`${moneyFormatMinuta((qAportesMin))} Ap. Min.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'center'}>
                      <Grid xs={12} children={`${moneyFormatMinuta((nuevoQAportesMin))} Ap. Min.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Adel. Prepactados" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(adelPrepactados) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(adelPrepactados, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(adelPrepactados) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(adelPrepactados, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Adel. Espontáneos" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(estadoActual?.adelantoEspontaneoAcumCAC) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(estadoActual?.adelantoEspontaneoAcumCAC, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(estadoActual?.adelantoEspontaneoAcumCAC) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(estadoActual?.adelantoEspontaneoAcumCAC, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Total Adelantos" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(totalAdelantos) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(totalAdelantos, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(totalAdelantos) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(totalAdelantos, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Prima Pendiente" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(estadoActual?.primaRestanteCAC) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(estadoActual?.primaRestanteCAC, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(nuevaPrimaPendiente) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(nuevaPrimaPendiente, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Adelantos Bonificables" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(totalAdelantos) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(totalAdelantos, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(nuevoTotalAdelBonificables) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(nuevoTotalAdelBonificables, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Bonif. Adel. Prepactados" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(adelPrepactadosBonif) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(adelPrepactadosBonif, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal((nuevoAdelPrepactadosBonif)) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(nuevoAdelPrepactadosBonif, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Bonif. Adel. Espontáneos" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(estadoActual?.adelantoEspontaneoBonifAcumCAC) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(estadoActual?.adelantoEspontaneoBonifAcumCAC, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal((nuevoAdelEspontaneosBonif)) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(nuevoAdelEspontaneosBonif, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Grado de Avance" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(valorContratoCAC) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(valorContratoCAC, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal((nuevoValorContratoCAC)) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(nuevoValorContratoCAC, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Capital Licitatorio" />} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal(estadoActual?.capitalLicitatorioCAC) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(estadoActual?.capitalLicitatorioCAC, estadoActual?.indice, claseContrato)?.cuotasEq.toFixed(3)} CuoEq.`} />
                    </Grid>} />
                    <Grid xs={4} children={<Grid display='flex' justifyContent={'flex-end'}>
                      <Grid xs={6} children={`$ ${moneyFormatMinuta(CAC2Nominal((nuevoCapitalLicitatorio)) / 100)}`} />
                      <Grid xs={6} children={`${getConversionesCAC(nuevoCapitalLicitatorio, estadoActual?.indice, nuevaClaseContrato)?.cuotasEq.toFixed(3)}CuoEq.`} />
                    </Grid>} />

                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container sx={{ paddingRight: '0.5em' }} fullwidth alignItems={'center'}>
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} color={theme.palette.success.main} children={' Puntos:'} />
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Origen'} />
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Destino'} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children="Por Referidos" />} />
                    <Grid xs={4} children={estadoActual?.puntosPorReferidos} />
                    <Grid xs={4} children={estadoActual?.puntosPorReferidos} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children=" Por Adelantos" />} />
                    <Grid xs={4} children={estadoActual?.puntosPorAdelantos.toFixed(1)} />
                    <Grid xs={4} children={nuevoPuntosPorAdelantos.toFixed(1)} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children=" Por Pago en Tiempo y Forma" />} />
                    <Grid xs={4} children={estadoActual?.puntosPagoTiempoYForma.toFixed(1)} />
                    <Grid xs={4} children={Math.ceil(nuevoPuntosPagoTiempoYForma.toFixed(1)).toFixed(1)} />

                    <Grid xs={4} children={<Typography sx={{ marginLeft: "0.5em" }} children=" Puntos Totales" />} />
                    <Grid xs={4} children={estadoActual?.puntos.toFixed(1)} />
                    <Grid xs={4} children={nuevoPuntosTotales.toFixed(1)} />

                  </Grid>
                </Grid>


                <Grid item xs={12}>
                  <Grid container sx={{ paddingRight: '0.5em' }} fullwidth alignItems={'center'}>
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} color={theme.palette.success.main} children={' Parámetros Cuota:'} />
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Nominal'} />
                    <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Cuotas Eq'} />

                    <Grid xs={4} sx={{ marginTop: '1em' }} children={<Typography sx={{ marginLeft: "0.5em" }} children="Cuota Pact." />} />
                    <Grid xs={4} children={<TextField type='number' sx={{ fontWeight: 600, }} InputProps={{
                      inputProps: {}, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />), endAdornment: (
                        <InputAdornment position="end" ><IconButton aria-label="toggle password visibility" onClick={() => setCuotaPactadaNominal(parseFloat(getMinCuotaNominal())?.toFixed(2))} onMouseDown={(e) => handleMouseDownInput(e)} > <ReplayIcon />
                        </IconButton></InputAdornment>)
                    }}
                      value={cuotaPactadaNominal}
                      onChange={e => setCuotaPactadaNominal(parseFloat(e.target.value))} />} />
                    <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }} sx={{ fontWeight: 600 }}
                      value={getConversionesCAC(nominal2CAC(cuotaPactadaNominal * 100, contrato?.fechaAplicacionDesde), indiceActual, nuevaClaseContrato).cuotasEq.toFixed(3)} />} />

                    <Grid xs={4} sx={{ marginTop: '1em' }} children={<Typography sx={{ marginLeft: "0.5em" }} children="Adel. Recu." />} />
                    <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                      value={getAdelantoRecurrenteNom()?.toFixed(2)} />} />
                    <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }}
                      value={getConversionesCAC(nominal2CAC(getAdelantoRecurrenteNom() * 100, contrato?.fechaAplicacionDesde), indiceActual, nuevaClaseContrato).cuotasEq.toFixed(3)} />} />

                    <Grid xs={4} sx={{ marginTop: '1em', p: '0.5em' }} children={<Typography children="Cuota Min." />} />
                    <Grid xs={4} children={<TextField className='noBorder' InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                      value={moneyFormatMinuta((getMinCuotaNominal())?.toFixed(2))} //Nom Original
                    />} />
                    <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }} sx={{ fontWeight: 600 }}
                      value={getConversionesCAC(nominal2CAC(getMinCuotaNominal() * 100, contrato?.fechaAplicacionDesde), indiceActual, nuevaClaseContrato).cuotasEq.toFixed(3)} />} />
                  </Grid>
                </Grid>

                <Grid xs={12} style={{ padding: '0.5rem' }}>
                  {msjFooter?.map((msj, i) => {
                    return (
                      <Typography color={theme.palette.danger.main} key={'MensajeErrorTitulares' + i}>{msj}</Typography>
                    )
                  })}

                </Grid>
              </Grid >
            </FormContainer >
          </Box >
        </Box>)
      };
      return (
        <Dialog TransitionComponent={Grow} maxWidth='lg' minWidth='lg' onClose={() => setShowEditarContratoForm(false)} open={showEditarContratoForm}>
          <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Edición Contrato ID {contrato?.contratoId}:</DialogTitle>
          <ModalConfirmacion />
          <DialogContent dividers>
            {step === 0 ?
              <SelectForm />
              :
              <>
                {step === 1 ? null :
                  <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={selectedTab} onChange={(event, newValue) => { if ([selectedTab, newValue].includes(2)) (setContrato({ ...contratoAux, fechaAplicacionDesde: new Date().valueOf() })); setSelectedTab(newValue) }} >
                      <Tab sx={{ fontWeight: "bold" }} label="Contratos" id={0} />
                      <Tab sx={{ fontWeight: "bold" }} label="Campañas" id={1} />
                      <Tab sx={{ fontWeight: "bold" }} disabled={!claseContrato.principal} label="Cambio de Tipología" id={2} />
                    </Tabs>
                  </Box>
                }
                <Box sx={{ flexGrow: 1, paddingTop: '1.5rem', paddingLeft: '1.5rem', width: '100%', borderColor: 'divider', height: '70vh' }}>
                  { //Tab ParámetrosContratos
                    selectedTab === 0 ?
                      <>
                        <Box>
                          <FormContainer defaultValues={{ ...contrato }} onSuccess={handleSubmit}>
                            <Grid container spacing={2}>
                              <Grid xs={4} style={{ padding: '0.5rem', paddingTop: '1rem' }}>
                                <Autocomplete
                                  filterOptions={filterOptions}
                                  id="combo-box-demo"
                                  options={getDropdownVendedores(getDropdownOptions(true))}
                                  renderInput={(params) => <TextField {...params} label="Vendedor:" />}
                                  value={contrato?.vendedorId}
                                  onChange={(e, value) => {
                                    handleChange('vendedorId', value)
                                  }}
                                />
                              </Grid>

                              <Grid xs={4} children={<Autocomplete
                                filterOptions={filterOptions}
                                id="combo-box-demo"
                                options={getDropdownAhorristas(getDropdownOptions(true))}
                                renderInput={(params) => <TextField {...params} label="Referido Por:" />}
                                value={contrato?.referenciadoId}
                                onChange={(e, value) => {
                                  handleChange('referenciadoId', value)
                                }}
                              />} style={{ padding: '0.5rem', paddingTop: '1rem' }} />

                              {step === 1 ?
                                <Grid xs={4} style={{ padding: '0.5rem', paddingTop: '1rem' }}>
                                  <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                      label="Fecha Creacion"
                                      inputFormat="DD/MM/YYYY"
                                      disableFuture
                                      value={!isNaN(contrato?.fechaCreacion) ? parseInt(contrato?.fechaCreacion) : contrato?.fechaCreacion?.valueOf()}
                                      onChange={(v) => { setContrato({ ...contrato, fechaAplicacionDesde: v.valueOf(), fechaCreacion: v.valueOf() }); setSocios(socios.map(s => ({ ...s, fechaAplicacionDesde: v.valueOf(), fechaInicioVigencia: v.valueOf() }))) }}
                                      renderInput={(params) => <TextField {...params} />}
                                    />
                                  </LocalizationProvider>
                                </Grid> :
                                <Grid xs={4} style={{ padding: '0.5rem', paddingTop: '1rem' }}>
                                  <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                      label="Fecha Aplicación de Edición"
                                      inputFormat="DD/MM/YYYY"
                                      disableFuture
                                      minDate={new Date(parseInt(contrato?.fechaCreacion)).setDate(new Date(parseInt(contrato?.fechaCreacion)).getDate() + 1)}
                                      value={!isNaN(contrato?.fechaAplicacionDesde) ? parseInt(contrato?.fechaAplicacionDesde) : contrato?.fechaAplicacionDesde?.valueOf()}
                                      onChange={(v) => {
                                        handleDateChange(v.valueOf())
                                        //  handleChange('fechaAplicacionDesde', v.valueOf());
                                        //  setSocios(socios.map(s => ({ ...s, fechaAplicacionDesde: v.valueOf() })))
                                      }}
                                      renderInput={(params) => <TextField {...params} />}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                              }
                              {step === 1 ?
                                <Grid xs={4} style={{ padding: '0.5rem', }}>
                                  <ClaseContratoSelector />
                                </Grid>
                                :
                                <Grid xs={4} sx={{ padding: '0.5rem', display: 'flex', justifyContent: 'flex-start' }}>
                                  <Grid xs={12} fontWeight={700} color={theme.palette.success.main} children={'Refuerzo:'} />
                                  <Grid xs={5} children={<FormControlLabel label="Prorrateado" control={<Checkbox checked={!contrato.refuerzo} onChange={e => { handleChange('refuerzo', !e.target.checked); setCampanasCreacion({ ...campanasCreacion, campanaRefuerzo: !e.target.checked ? false : campanasContrato?.campanaRefuerzo }) }} />} />} />
                                  <Grid xs={5} children={<FormControlLabel label="Semestral" control={<Checkbox checked={contrato.refuerzo} onChange={e => { handleChange('refuerzo', e.target.checked) }} />} />} />
                                </Grid>
                              }
                              <Grid xs={4} style={{ padding: '0.5rem' }}>
                                <FormControl fullWidth >
                                  <InputLabel id="seleccion-estado-contrato">Estado:</InputLabel>
                                  <Select labelId="seleccion-estado-contrato" value={contrato.estado} label="Estado" onChange={e => handleChange('estado', e.target.value)}>
                                    {['Activo', 'Inactivo', 'Suspendido', 'Excluido', 'Finalizado']?.map(x => <MenuItem value={x}>{x}</MenuItem>)}
                                  </Select>
                                </FormControl>
                              </Grid>

                              <Grid xs={4} style={{ padding: '0.5rem', }}>
                                <Grid xs={10} children={<Typography children={`Prima ${parseInt(contrato?.perPrimaAdjudicacion * 100)}%`} />} />
                                <Grid xs={12} children={<Slider value={contrato?.perPrimaAdjudicacion} disabled={step > 1} onChange={e => handleChange('perPrimaAdjudicacion', e.target.value)} valueLabelDisplay="auto" step={0.05} marks min={0} max={0.2} />} />
                              </Grid>


                              {step === 1 ?
                                <>
                                  <Grid xs={8} container direction='row' style={{ padding: '0.5rem', display: 'inline-flex', alingItems: 'strech', justifyContent: 'space-between' }}>
                                    <Grid xs={12} fontWeight={700} color={theme.palette.success.main} children={'Campañas de Creación:'} />
                                    <Grid xs={4} style={{ paddingBottom: '0.5rem', }} children={<FormControlLabel label="Segundo Aporte Mes n+1" control={<Checkbox checked={!campanasCreacion?.campanaNoCuota} onChange={e => { setCampanasCreacion({ ...campanasCreacion, campanaNoCuota: false, campanaPAE: { ...campanasCreacion?.campanaPAE, fechaFinalizacion: e.target.checked ? new Date(contrato?.fechaCreacion).setMonth(new Date(contrato?.fechaCreacion).getMonth() + 4) : new Date(contrato?.fechaCreacion).setMonth(new Date(contrato?.fechaCreacion).getMonth() + 3) } }) }} />} />} />
                                    <Grid xs={4} style={{ paddingBottom: '0.5rem', }} children={<FormControlLabel label="Segundo Aporte Mes n+2" control={<Checkbox checked={campanasCreacion?.campanaNoCuota} onChange={e => { setCampanasCreacion({ ...campanasCreacion, campanaNoCuota: true, campanaPAE: { ...campanasCreacion?.campanaPAE, fechaFinalizacion: !e.target.checked ? new Date(contrato?.fechaCreacion).setMonth(new Date(contrato?.fechaCreacion).getMonth() + 4) : new Date(contrato?.fechaCreacion).setMonth(new Date(contrato?.fechaCreacion).getMonth() + 3) } }) }} />} />} />
                                    <Grid xs={4} style={{ paddingBottom: '0.5rem', }} children={<FormControlLabel label="Primer Refuerzo Mes n+3" control={<Checkbox disabled={!contrato?.refuerzo} checked={campanasCreacion?.campanaRefuerzo} onChange={e => { setCampanasCreacion({ ...campanasCreacion, campanaRefuerzo: e.target.checked }) }} />} />} />
                                    <Grid xs={campanasCreacion?.campanaPAE?.campanaPAE ? 1 : 12} children={<IconButton style={{ marginBottom: '.4em', paddingLeft: 0 }} color={campanasCreacion?.campanaPAE?.campanaPAE ? 'primary' : 'secondary'} size={'large'} onClick={() => setCampanasCreacion({ ...campanasCreacion, campanaPAE: { ...campanasCreacion?.campanaPAE, campanaPAE: !campanasCreacion?.campanaPAE?.campanaPAE } })} children={<GridAction label={'Campaña ALTA TEMPRANA'} key={'CampañaPAE'} Icon={StarsIcon} />} />} />
                                    {campanasCreacion?.campanaPAE?.campanaPAE ?
                                      <>
                                        <Grid children={<TextField sx={{ width: '100%' }}
                                          disabled={!(campanasCreacion?.campanaPAE?.campanaPAE || currentUser?.roles?.includes('Admin'))}
                                          value={campanasCreacion?.campanaPAE?.porcentaje}
                                          onChange={(e) => {
                                            setCampanasCreacion({ ...campanasCreacion, campanaPAE: { ...campanasCreacion?.campanaPAE, porcentaje: e.target.value } })
                                          }}
                                          InputProps={{ inputProps: { min: 0, max: 100 } }}
                                          id="outlined-basic" type='number' label='%' defaultValue={0}
                                          error={campanasCreacion?.campanaPAE?.porcentaje > 100 || campanasCreacion?.campanaPAE?.porcentaje < 0}
                                        />} xs={3} />
                                        <Grid xs={2} children={<TextField sx={{ width: '100%' }}
                                          disabled={!(campanasCreacion?.campanaPAE?.campanaPAE || currentUser?.roles?.includes('Admin'))}
                                          value={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(getCuotaPAE() * (campanasCreacion?.campanaPAE?.porcentaje / 100) / 100).replace("ARS", "")}
                                          className='noBorder'
                                          InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                                          id="outlined-basic" label='' defaultValue={0}
                                        />} />
                                        <Grid xs={4} children={<LocalizationProvider dateAdapter={AdapterDayjs}>
                                          <DesktopDatePicker
                                            disabled={!(campanasCreacion?.campanaPAE?.campanaPAE || currentUser?.roles?.includes('Admin'))}
                                            label={"Fecha Fin"}
                                            inputFormat="DD/MM/YYYY"
                                            value={(parseInt(campanasCreacion?.campanaPAE?.fechaFinalizacion))}
                                            color={"secondary"}
                                            onChange={(v) => {
                                              setCampanasCreacion({ ...campanasCreacion, campanaPAE: { ...campanasCreacion?.campanaPAE, fechaFinalizacion: (new Date(v).setHours(23, 59, 0, 0)).valueOf() } })
                                            }}
                                            renderInput={(params) => <TextField error={false}{...params} />}
                                          />
                                        </LocalizationProvider>} sx={{ paddingLeft: '0.5rem' }} />
                                      </>
                                      : null}
                                  </Grid>
                                  <Grid xs={4} container direction='row' sx={{ padding: '0.5rem', display: 'flex', justifyContent: 'flex-start' }}>
                                    <Grid xs={12} fontWeight={700} color={theme.palette.success.main} children={'Refuerzo:'} />
                                    <Grid xs={6} item children={<FormControlLabel label="Prorrateado" control={<Checkbox checked={!contrato.refuerzo} onChange={e => { handleChange('refuerzo', !e.target.checked); setCampanasCreacion({ ...campanasCreacion, campanaRefuerzo: !e.target.checked ? false : campanasContrato?.campanaRefuerzo }) }} />} />} />
                                    <Grid xs={6} item children={<FormControlLabel label="Semestral" control={<Checkbox checked={contrato.refuerzo} onChange={e => { handleChange('refuerzo', e.target.checked) }} />} />} />
                                  </Grid>
                                </>
                                :
                                null}

                              {//Parámetros CuotaCreacion o CuotaActual
                                step === 1 ?
                                  <Grid item xs={12}>
                                    <Grid container sx={{ paddingRight: '0.5em' }} fullwidth alignItems={'center'}>
                                      <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} color={theme.palette.success.main} children={' Parámetros Cuota:'} />
                                      <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Nominal'} />
                                      <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Cuotas Eq'} />

                                      <Grid xs={4} sx={{ marginTop: '1em', p: '0.5em' }} children={<Typography children="Adel. Inic." />} />
                                      <Grid xs={4} children={<TextField type='number'
                                        InputProps={{
                                          startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />), endAdornment: (
                                            <InputAdornment position="end" ><IconButton aria-label="toggle password visibility" onClick={() => handleChange('adelantoInicialNominal', 0.00)} onMouseDown={(e) => handleMouseDownInput(e)} > <ReplayIcon />
                                            </IconButton></InputAdornment>)
                                        }}
                                        value={contrato?.adelantoInicialNominal} //Nom Original
                                        onChange={e => handleChange('adelantoInicialNominal', parseFloat(e.target.value))} />} />
                                      <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }} sx={{ fontWeight: 600 }}
                                        value={getConversionesCAC(nominal2CAC(contrato?.adelantoInicialNominal * 100, new Date(parseInt(contrato?.fechaCreacion))), indiceCreacion, claseContrato).cuotasEq.toFixed(3)} />} />

                                      <Grid xs={4} sx={{ marginTop: '1em' }} children={<Typography sx={{ marginLeft: "0.5em" }} children="Cuota Pact." />} />
                                      <Grid xs={4} children={<TextField helperText={cuotaPactadaNominal < getMinCuotaNominal() - 0.01 ? 'La cuota no podrá ser menor a $ ' + getMinCuotaNominal()?.toFixed(2) : ''} error={cuotaPactadaNominal < getMinCuotaNominal() - 0.01 ? true : false} type='number' sx={{ fontWeight: 600, }} InputProps={{
                                        inputProps: { min: getMinCuotaNominal()?.toFixed(2) }, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />), endAdornment: (
                                          <InputAdornment position="end" ><IconButton aria-label="toggle password visibility" onClick={() => setCuotaPactadaNominal(parseFloat(getMinCuotaNominal())?.toFixed(2))} onMouseDown={(e) => handleMouseDownInput(e)} > <ReplayIcon />
                                          </IconButton></InputAdornment>)
                                      }}
                                        value={cuotaPactadaNominal}
                                        onChange={e => setCuotaPactadaNominal(parseFloat(e.target.value))} />} />
                                      <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }} sx={{ fontWeight: 600 }}
                                        value={getConversionesCAC(nominal2CAC(cuotaPactadaNominal * 100, new Date(parseInt(contrato?.fechaCreacion))), indiceCreacion, claseContrato).cuotasEq.toFixed(3)} />} />

                                      <Grid xs={4} sx={{ marginTop: '1em' }} children={<Typography sx={{ marginLeft: "0.5em" }} children="Adel. Recu." />} />
                                      <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                                        value={getAdelantoRecurrenteNom()?.toFixed(2)} />} />
                                      <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }}
                                        value={getConversionesCAC(nominal2CAC(getAdelantoRecurrenteNom() * 100, new Date(parseInt(contrato?.fechaCreacion))), indiceCreacion, claseContrato).cuotasEq.toFixed(3)} />} />
                                    </Grid>
                                  </Grid>
                                  :
                                  <Grid item xs={12}>
                                    <Grid container sx={{ paddingRight: '0.5em' }} fullwidth alignItems={'center'}>
                                      <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} color={theme.palette.success.main} children={' Parámetros Cuota:'} />
                                      <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Nominal'} />
                                      <Grid xs={4} sx={{ p: '0em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Cuotas Eq'} />

                                      <Grid xs={4} sx={{ marginTop: '1em' }} children={<Typography sx={{ marginLeft: "0.5em" }} children="Cuota Pact." />} />
                                      <Grid xs={4} children={<TextField type='number' sx={{ fontWeight: 600, }} InputProps={{
                                        inputProps: {}, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />), endAdornment: (
                                          <InputAdornment position="end" ><IconButton aria-label="toggle password visibility" onClick={() => setCuotaPactadaNominal(parseFloat(getMinCuotaNominal())?.toFixed(2))} onMouseDown={(e) => handleMouseDownInput(e)} > <ReplayIcon />
                                          </IconButton></InputAdornment>)
                                      }}
                                        value={cuotaPactadaNominal}
                                        onChange={e => setCuotaPactadaNominal(parseFloat(e.target.value))} />} />
                                      <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }} sx={{ fontWeight: 600 }}
                                        value={getConversionesCAC(nominal2CAC(cuotaPactadaNominal * 100, contrato?.fechaAplicacionDesde), indiceActual, claseContrato).cuotasEq.toFixed(3)} />} />

                                      <Grid xs={4} sx={{ marginTop: '1em' }} children={<Typography sx={{ marginLeft: "0.5em" }} children="Adel. Recu." />} />
                                      <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                                        value={getAdelantoRecurrenteNom()?.toFixed(2)} />} />
                                      <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }}
                                        value={getConversionesCAC(nominal2CAC(getAdelantoRecurrenteNom() * 100, contrato?.fechaAplicacionDesde), indiceActual, claseContrato).cuotasEq.toFixed(3)} />} />

                                      <Grid xs={4} sx={{ marginTop: '1em', p: '0.5em' }} children={<Typography children="Cuota Min." />} />
                                      <Grid xs={4} children={<TextField className='noBorder' InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                                        value={moneyFormatMinuta((getMinCuotaNominal())?.toFixed(2))} //Nom Original
                                        onChange={e => handleChange('adelantoInicialNominal', parseFloat(e.target.value))} />} />
                                      <Grid xs={4} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }} sx={{ fontWeight: 600 }}
                                        value={getConversionesCAC(nominal2CAC(getMinCuotaNominal() * 100, contrato?.fechaAplicacionDesde), indiceActual, claseContrato).cuotasEq.toFixed(3)} />} />
                                    </Grid>
                                  </Grid>}

                              <Grid item xs={12}><Typography>Socios</Typography></Grid>
                              <Grid item xs={12}>
                                <TransitionGroup sx={{ width: '100%' }}>
                                  {(socios)?.map((socio, i) => {
                                    return (
                                      <Collapse key={`fragment-alta-pre-contrato-${i}`} sx={{ width: '100%' }}>
                                        <Grid container direction='row' xs={12} spacing={2} style={{ padding: '0.5rem', display: 'flex', alingItems: "strech" }}>
                                          <Grid xs={6} style={{ padding: '0.5rem' }}>
                                            <Autocomplete
                                              id="combo-box-demo"
                                              options={(getDropdownAhorristas(getDropdownOptions(true)))}
                                              sx={{ width: '100%' }}
                                              renderInput={(params) => <TextField {...params} label="Socio" />}
                                              onChange={(e, value) => { handelSocioChange(value, i) }}
                                              value={socio.socio}
                                            />
                                          </Grid>
                                          <Grid xs={2} style={{ padding: '0.5rem' }}>
                                            <TextField sx={{ width: '100%' }}
                                              value={socio.porcentaje}
                                              onChange={(e) => {
                                                const newSocios = [...socios];
                                                newSocios[i].porcentaje = e.target.value;
                                                setSocios(newSocios)
                                              }}
                                              InputProps={{ inputProps: { min: 0, max: 100 } }}
                                              id="outlined-basic" type='number' label='%' defaultValue={0}
                                            />
                                          </Grid>
                                          <Grid xs={2} style={{ padding: '0.5rem' }}>
                                            <Button
                                              value={socio.titularPrincipal}
                                              onClick={() => {
                                                let newSocios = [...socios];
                                                newSocios = newSocios.map((sa, ia) => ia === i ? ({ ...sa, titularPrincipal: true }) : ({ ...sa, titularPrincipal: false }))
                                                //newSociosAux[i].titularPrincipal = !newSociosAux[i].titularPrincipal;
                                                setSocios(newSocios)
                                              }}
                                              color={socio.titularPrincipal ? 'primary' : 'secondary'}
                                              children={<><Typography children={'Titular Principal'} /><VerifiedIcon /></>}
                                            />
                                          </Grid>
                                          <Grid xs={1} style={{ padding: '0.5rem' }}>
                                            <IconButton className="mb-3" variant="contained" color='danger' onClick={_ => removeSocio(i)}><DeleteIcon /></IconButton>
                                          </Grid>
                                        </Grid>
                                      </Collapse>
                                    )
                                  })}
                                </TransitionGroup>
                              </Grid>
                              <Grid xs={12} style={{ padding: '0.5rem' }}>
                                <Button onClick={() => setSocios([...socios, { socioId: null, porcentaje: 0, titularPrincipal: false, fechaAplicacionDesde: contrato?.fechaAplicacionDesde, fechaInicioVigencia: step === 1 ? contrato?.fechaCreacion : contrato?.fechaAplicacionDesde }])}>Agregar</Button>
                              </Grid>
                              <Grid xs={12} style={{ padding: '0.5rem' }}>
                                {msjFooter?.map((msj, i) => {
                                  return (
                                    <Typography color={theme.palette.danger.main} key={'MensajeErrorTitulares' + i}>{msj}</Typography>
                                  )
                                })}

                              </Grid>
                            </Grid >
                          </FormContainer >
                        </Box >
                      </>
                      : null}
                  { //Tab Campañas
                    selectedTab === 1 ?
                      <Box minHeight='100%' sx={{ minWidth: '50em' }}>
                        <Grid container spacing={2} sx={{ marginTop: '0.5rem' }}>
                          <Fragment>
                            <TransitionGroup >
                              {campanasContrato?.map((campana, i) => {
                                return (
                                  <Collapse key={`fragment-alta-pre-contrato-campana-${i}`}>
                                    <Grid container direction='row' xs={12} spacing={2} style={{ padding: '0.5rem', display: 'flex', alingItems: "strech" }}>
                                      <Grid xs={3} style={{ padding: '0.5rem' }}>
                                        <Autocomplete
                                          disableClearable
                                          disabled={campana.creacion}
                                          getOptionDisabled={(option) =>
                                            (!contrato?.refuerzo && ['Per Refuerzo Ahorro', 'Bonificación Refuerzo'].includes(option.label) ||
                                              contrato.perPrimaAdjudicacion === 0 && ['Per Cuota Prima', 'Bonificación Prima'].includes(option.label)) ||
                                            (!(contrato.adelantoRecurrenteCAC > 0.0009) && ['Per Adelanto Prepactado', 'Bonificación Adelanto Prepactado'].includes(option.label) ||
                                              contrato?.adelantoInicialNominal === 0 && ['Bonificación Adelanto Inicial'].includes(option.label)) ||
                                            ((contrato.fechaCreacion > new Date(contrato.fechaAplicacionDesde)?.setDate(1).valueOf()) && ['Per Cupon'].includes(option.label))
                                          }
                                          id="combo-box-demo"
                                          options={getDropdownTiposCampanas()}
                                          sx={{ width: '100%' }}
                                          renderInput={(params) => <TextField {...params} label={campana.creacion ? "Campaña creación" : "Campaña"} />}
                                          onChange={(e, value) => {
                                            const newCampanas = [...campanasContrato];
                                            newCampanas[i].tipo = value;
                                            setCampanasContrato(newCampanas)
                                          }}
                                          value={campana.tipo}
                                        />
                                      </Grid>
                                      <Grid xs={2} style={{ padding: '0.5rem' }}>
                                        <TextField sx={{ width: '100%' }}
                                          disabled={campana.creacion}
                                          value={campana.parametros.porcentaje}
                                          onChange={(e) => {
                                            const newCampanas = [...campanasContrato];
                                            newCampanas[i].parametros.porcentaje = e.target.value;
                                            setCampanasContrato(newCampanas)
                                          }}
                                          InputProps={{ inputProps: { min: 0, max: 100 } }}
                                          id="outlined-basic" type='number' label='%' defaultValue={0}
                                        />
                                      </Grid>
                                      <Grid xs={2} style={{ padding: '0.5rem' }}>
                                        <TextField sx={{ width: '100%' }}
                                          disabled={campana.creacion}
                                          value={getImporteCampana(campana) === 'N/A' ? 'N/A' : new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(getImporteCampana(campana)).replace("ARS", "")}
                                          className='noBorder'
                                          InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                                          id="outlined-basic" label='' defaultValue={0}
                                        />
                                      </Grid>
                                      <Grid xs={2} style={{ padding: '0.5rem' }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                          <DesktopDatePicker
                                            disabled={campana.creacion}
                                            label="Fecha Inicio"
                                            inputFormat="DD/MM/YYYY"
                                            value={(parseInt(campana.fechaInicio))}
                                            onChange={(v) => {
                                              const newCampanas = [...campanasContrato];
                                              newCampanas[i].fechaInicio = (new Date(v).setHours(0, 0, 0, 0)).valueOf();
                                              setCampanasContrato(newCampanas)
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                          />
                                        </LocalizationProvider>
                                      </Grid>
                                      <Grid xs={2} style={{ padding: '0.5rem' }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                          <DesktopDatePicker
                                            label={campana.fechaFinalizacion === null ? ' ' : "Fecha Fin"}
                                            inputFormat="DD/MM/YYYY"
                                            value={(parseInt(campana.fechaFinalizacion))}
                                            disabled={campana.fechaFinalizacion === null || campana.creacion}
                                            color={"secondary"}
                                            error={false}
                                            onChange={(v) => {
                                              const newCampanas = [...campanasContrato];
                                              newCampanas[i].fechaFinalizacion = (new Date(v).setHours(23, 59, 0, 0)).valueOf();
                                              setCampanasContrato(newCampanas)
                                            }}
                                            renderInput={(params) => <TextField error={false}{...params} />}
                                          />
                                        </LocalizationProvider>
                                      </Grid>
                                      <Grid xs={0.5} style={{ padding: '0.5rem' }}>
                                        <IconButton disabled={campana.creacion} color={(campana.fechaFinalizacion) === null ? "primary" : "secondary"} onClick={() => {
                                          const newCampanas = [...campanasContrato];
                                          newCampanas[i].fechaFinalizacion = newCampanas[i].fechaFinalizacion === null ? new Date().valueOf() : null;
                                          setCampanasContrato(newCampanas)
                                        }} sx={{ marginTop: '0.5rem' }}
                                          children={<FechaFinAction label={'Indefinido'}
                                            key={i}
                                            Icon={AllInclusiveIcon} />} />
                                      </Grid>
                                      <Grid xs={0.5} style={{ padding: '1rem' }}>
                                        <IconButton disabled={campana.creacion} className="mb-3" variant="contained" color='danger' onClick={_ => removeCampana(i)}><DeleteIcon /></IconButton>
                                      </Grid>
                                      {campana.tipo &&
                                        <Grid xs={12} style={{ paddingLeft: '.5rem' }}>
                                          <Typography sx={{ fontSize: 14, fontStyle: 'italic' }}>{getHelperTextCampana(campana.tipo)}</Typography>
                                        </Grid>}
                                      <Grid xs={12} style={{ paddingLeft: '.5rem' }}>
                                        {campana?.documento?.documentoId ?
                                          <>
                                            <Button disabled={currentUser?.permisos?.includes("export-data") ? false : true} color={'info'} onClick={() => handleOpenUrl(campana?.documento?.signedUrl)}// icon={<GridAction label={'Abrir Doc'} Icon={OpenInNewIcon} />} />
                                              children={<><Typography  children={`Doc : ${campana.documento.nombre}`} /><OpenInNewIcon/></>} />
                                          </>
                                          :
                                          campana.documento ?
                                            <Grid sx={{ display: 'inline-flex' }}>
                                              <IconButton sx={{zoom: 0.8}} onClick={(e) => {
                                                const newCampanas = [...campanasContrato];
                                                newCampanas[i].documento = null;
                                                setCampanasContrato(newCampanas);
                                              }} children={<ClearIcon color="danger" />} />
                                              <Typography children={`Doc seleccionado: ${campana.documento.name}`} />
                                            </Grid> :
                                            <><InputFile title={"Documentos " + campana.campanaId} multiple={false} docId={'documentos'} onChange={(e) => {
                                              const newCampanas = [...campanasContrato];
                                              newCampanas[i].documento = e.target.files[0];
                                              setCampanasContrato(newCampanas);
                                            }} /></>
                                        }
                                      </Grid>
                                      <Grid xs={12}style={{ padding: '.5rem' }}>
                                      <Divider />
                                      </Grid>
                                    </Grid>
                                  </Collapse >
                                )
                              })}
                            </TransitionGroup>
                            <Grid xs={12} style={{ padding: '0.5rem', paddingTop: '1rem' }}>
                              <Button onClick={() => setCampanasContrato([...campanasContrato, campanaDflt])}>Agregar</Button>
                            </Grid>
                            <Grid xs={12} style={{ padding: '0.5rem' }}>
                              {msjFooter?.map((msj, i) => {
                                return (
                                  <Typography color={theme.palette.danger.main} key={'MensajeErrorTitulares' + i}>{msj}</Typography>
                                )
                              })}
                            </Grid>
                          </Fragment>
                        </Grid>
                      </Box> : null}
                  { //Tab Cambio de Tipología
                    selectedTab === 2 ?
                      <CambioTipologiaForm /> : null}
                </Box>
              </>
            }
          </DialogContent>
          <DialogActions>
            {step > 0 ?
              <Button variant="text" sx={{ fontWeight: "bold" }} onClick={() => { setContrato({ ...contratoAux }); setSocios([...sociosAux]); setStep(0) }}>{"Volver"}</Button>
              : null}
            <Button variant="outlined" sx={{ fontWeight: "bold" }} onClick={() => setShowEditarContratoForm(false)}>{"Cancelar"}</Button>
            {step > 0 ?
              <Button variant="contained" sx={{ fontWeight: "bold", marginRight: '5px' }} onClick={() => handleValidation()}>{"Aceptar"}</Button>
              : null}
          </DialogActions>
        </Dialog>
      )
    };
    const GridAction = (props) => {
      const [anchorEl, setAnchorEl] = useState(null);

      const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget)
      };

      const handlePopoverClose = () => {
        setAnchorEl(null)
      };
      const { label, key, Icon } = props;
      const open = Boolean(anchorEl);
      return (
        <Fragment key={key + label}>
          <Icon aria-owns={open ? label : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}> </Icon>
          <Popover
            id={label}
            sx={{
              pointerEvents: 'none',
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{label}</Typography>
          </Popover>
        </Fragment>
      )
    };
    const CampanasActivasButton = ({ campanasActivas }) => {
      return (
        <div>
          <MuiTooltip title={<div style={{ padding: '1rem', paddingTop: '0.5rem' }}>
            <Typography sx={{ p: 1, fontWeight: 700 }}>{`Campañas Activas (${campanasActivas?.length ?? 0}):`}</Typography>
            {campanasActivas?.map((c, i) => <Typography key={'TipoCampanaActivaRow' + i}>{`* ${tiposCampana?.find(tc => parseInt(c.tipoCampanaId) === parseInt(tc.tipoCampanaId))?.nombre} %${parseInt(100 * c?.parametros?.porcentaje)}`}</Typography>)}
          </div>}>
            <CampaignIcon color={campanasActivas?.length > 0 ? "info" : "secondary"} />
          </MuiTooltip>

        </div>
      );
    };
    const autosizeOptions = {
      includeHeaders: false,
      includeOutliers: true,
      expand: false,
    };
    const columns = [
      { field: 'contratoId', headerName: 'ID', width: 40 },
      { field: 'serie', headerName: 'Serie', width: 50 },
      { field: 'claseContratoId', headerName: 'Clase', width: 120, valueGetter: v => clasesContratos?.find(x => x.claseContratoId === v?.value)?.codigo },
      {
        field: 'adelantoInicialNominal',
        headerName: 'Adel. Ini. Nom',
        width: 150,
        valueGetter: ({ value }) => parseFloat(value),
        valueFormatter: ({ value }) => '$' + moneyFormatMinuta(value / 100),
        renderCell: ({ value }) => '$' + moneyFormatMinuta(value / 100)
      },
      {
        field: 'adelantoInicialCAC',
        headerName: 'Adel. Ini. CAC',
        width: 150,
        valueGetter: ({ value, row }) => parseFloat(row.adelantoInicialNominal) / getIndiceAt(row.fechaCreacion, - 2)?.cac,
        renderCell: ({ value }) => value.toFixed(3)
      },
      {
        field: 'adelantoRecurrenteNominal',
        headerName: 'Adel. Rec. Nom',
        width: 150,
        valueGetter: ({ value, row }) => parseFloat(row.adelantoRecurrenteCAC) * getIndiceAt(new Date().setMonth(new Date().getMonth() - 2)).cac,
        valueFormatter: ({ value }) => '$' + moneyFormatMinuta(value / 100),
        renderCell: ({ value }) => '$' + moneyFormatMinuta(value / 100)
      },
      {
        field: 'adelantoRecurrenteCAC',
        headerName: 'Adel. Rec. CAC',
        width: 150,
        valueGetter: ({ value }) => value,
        //valueFormatter: ({ value }) => '$' + moneyFormatMinuta(value / 100),
        //renderCell: ({ value }) => '$' + moneyFormatMinuta(value / 100)
      },
      //(Aporte minimo =( Valore del bien - adelanto inicial *(1+bonificador) - prima )/ 300 o 350
      {
        field: 'aporteMinPersonalizadoMenNominal',
        headerName: 'Apor. Min. P. Nom.',
        width: 150,
        valueGetter: ({ value, row }) => {
          let claseContrato = clasesContratos?.find(x => x.claseContratoId === row.claseContratoId);
          let valorBienCAC = claseContrato?.valorObjetoAhorroCAC;
          let indiceCreacion = getIndiceAt(new Date(parseInt(row.fechaCreacion)).setMonth(new Date(parseInt(row.fechaCreacion)).getMonth() - 2))?.cac;
          let indiceActual = getIndiceAt(new Date().setMonth(new Date().getMonth() - 2)).cac;
          let adelantoInicialBonCAC = (parseFloat(row.adelantoInicialNominal) / indiceCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial);
          let nCuotas = row.mesRefuerzoSemestral1 || row.mesRefuerzoSemestral2 ? 350 : 300;
          return ((valorBienCAC - adelantoInicialBonCAC) * (1 - row.perPrimaAdjudicacion) / nCuotas) * indiceActual;
        },
        valueFormatter: ({ value }) => '$' + moneyFormatMinuta(value / 100),
        renderCell: ({ value }) => '$' + moneyFormatMinuta(value / 100)
      },
      //(Aporte minimo =( Valore del bien - adelanto inicial *(1+bonificador) - prima )/ 300 o 350
      {
        field: 'aporteMinPersonalizadoMenCAC',
        headerName: 'Adel. Min. P. CAC',
        width: 150,
        valueGetter: ({ value, row }) => {
          let claseContrato = clasesContratos?.find(x => x.claseContratoId === row.claseContratoId);
          let valorBienCAC = claseContrato?.valorObjetoAhorroCAC;
          let indiceCreacion = getIndiceAt(new Date(parseInt(row.fechaCreacion)).setMonth(new Date(parseInt(row.fechaCreacion)).getMonth() - 2))?.cac;
          let indiceActual = getIndiceAt(new Date().setMonth(new Date().getMonth() - 2)).cac;
          let adelantoInicialBonCAC = (parseInt(row.adelantoInicialNominal) / indiceCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial);
          let nCuotas = row.mesRefuerzoSemestral1 || row.mesRefuerzoSemestral2 ? 350 : 300;
          return ((valorBienCAC * (1 - row.perPrimaAdjudicacion)) - adelantoInicialBonCAC) / nCuotas;
        },
        //valueFormatter: ({ value }) => '$' + moneyFormatMinuta(value / 100),
        //renderCell: ({ value }) => '$' + moneyFormatMinuta(value / 100)
      },
      {
        field: 'perPrimaAdjudicacion',
        headerName: 'Prima',
        width: 80,
        valueGetter: ({ value }) => parseFloat(value),
        valueFormatter: ({ value }) => parseInt(value * 100) + '%',
        renderCell: ({ value }) => parseInt(value * 100) + '%',
      },
      // {
      //   field: 'mesRefuerzoSemestral1',
      //   headerName: 'Mes Refuerzo 1',
      //   width: 120,
      //   valueGetter: ({ value }) => value,
      //   valueFormatter: v => meses[v.value],
      //   renderCell: v => meses[v.value - 1]
      // },
      {
        field: 'mesRefuerzoSemestral1',
        headerName: 'Refuerzo',
        width: 90,
        valueGetter: ({ value }) => value,
        valueFormatter: v => v.value !== null ? 1 : 0,
        renderCell: v => v.value !== null ? 'Semestral' : 'Prorrateado'
      },
      {
        field: 'estado',
        headerName: 'Estado',
        width: 80
      },
      {
        field: 'etapa',
        headerName: 'Etapa',
        width: 80,
        renderCell: v => ['Ahorro', 'Adjudicado', 'Tenencia', 'Cencelado'].find((e, i) => v.row.etapa - 1 === i)
      },
      {
        field: 'editor',
        headerName: 'Editor',
        width: 150,
        valueGetter: v => parseInt(v.row?.editorId),
        valueFormatter: v => getNombrePersona(v.value),
        renderCell: v => getNombrePersona(v.value),
      },
      {
        field: 'editorId',
        headerName: 'Editor ID',
        width: 150,
        valueGetter: ({ value }) => parseInt(value),
        valueFormatter: ({ value }) => value,
        renderCell: ({ value }) => value,
      },
      {
        field: 'titulares',
        headerName: 'Titular',
        width: 200,
        valueGetter: ({ value, row }) => getNombrePersona((titularidades || [])?.find(x => x.contratoId === row?.contratoId && x.titularPrincipal)?.personaId),
      },
      {
        field: 'titularId',
        headerName: 'Titular ID',
        width: 80,
        valueGetter: ({ value, row }) => (titularidades || [])?.find(x => x.contratoId === row?.contratoId && x.titularPrincipal)?.personaId,
      },
      {
        field: 'campanasActivas',
        headerName: 'Campañas Activas',
        width: 80,
        valueGetter: (v) => (campanas || [])?.find(x => parseInt(x.contratoId) === v.row?.contratoId && (parseInt(x.fechaInicio) < Date.now() && parseInt(x.fechaFinalizacion) > Date.now())) ? 1 : 0,
        renderCell: v => v.value === 0 ? 'No' : <CampanasActivasButton campanasActivas={(campanas || [])?.filter(x => parseInt(x.contratoId) === v.row?.contratoId && (parseInt(x.fechaInicio) < Date.now() && parseInt(x.fechaFinalizacion) > Date.now()))} />,
      },
      {
        field: 'vendedor',
        headerName: 'Vendedor',
        width: 150,
        valueGetter: v => v.row.vendedorId,
        valueFormatter: v => getNombrePersona(v.value),
        renderCell: v => getNombrePersona(v.value),
      },
      {
        field: 'vendedorId',
        headerName: 'Vendedor ID',
        width: 150,
      },
      {
        field: 'fechaCreacion',
        headerName: 'F. Creación',
        width: 130,
        valueGetter: v => parseInt(v.value),
        valueFormatter: v => new Date(parseInt(v.value)).toLocaleDateString(),
        renderCell: v => new Date(parseInt(v.value)).toLocaleDateString(),
        sortComparator: fechaSortComparator
      },
      {
        field: 'fechaFirma',
        headerName: 'F. Firma',
        width: 100,
        valueGetter: v => v.row.fechaFirma ? getFecha(parseInt(v.row.fechaFirma)) : null,
        renderCell: v =>
          v.row.fechaFirma ? getFecha(v.row.fechaFirma) :
            <Button
              key={`columna-contrato-fecha-firma${v.row.contratoId}`}
              onClick={() => { setContratoSeleccionado(v.row); setFirmarContratoModal(true) }}
              disabled={!(currentUser?.permisos?.includes('writeContrato'))}>
              Firmar
            </Button>, sortComparator: fechaSortComparator
      },
      {
        field: 'fechaPerfeccionamiento',
        headerName: 'F. Perfeccionamiento',
        width: 100,
        valueGetter: v => parseInt(v.value),
        valueFormatter: v => new Date(parseInt(v.value)).toLocaleDateString(),
        renderCell: v =>
          v.row.fechaPerfeccionamiento ?
            new Date(v.value).toLocaleDateString() :
            <Button key={`columna-contrato-fecha-perfeccionamiento${v.row.contratoId}`}
              disabled={!((v.row.fechaFirma !== null) && (currentUser?.permisos?.includes('altaPersona')))}
              onClick={() => { setContratoSeleccionado(v.row); setPerfeccionarContratoModal(true) }}>
              Firmar
            </Button>
      },
      {
        field: 'actions', headerName: 'Acciones', width: 180, type: 'actions', renderCell: v =>
          <>
            <GridActionsCellItem
              key={v.row.contratoId + '-verDetallesContratosGridAction'}
              color={'primary'}
              onClick={() => { ; setContratoSeleccionado(v.row.contratoId); setShowDetallesContrato(true); }}
              icon={<GridAction
                label={'Ver Detalles'}
                key={v.row.contratoId}
                Icon={VisibilityIcon}
              />}
            />
            <GridActionsCellItem
              key={v.row.contratoId + '-documentosContratoGridAction'}
              disabled={currentUser?.permisos?.includes('writeContrato') ?
                (v.row.fechaFirma &&
                  (((currentUser?.roles?.includes('Vendedor Externo') || (currentUser?.roles?.includes('Administrador de Cartera')))
                    || (currentUser?.roles?.includes('Ejecutivo de Cuentas') || (currentUser?.roles?.includes('Jefe Vendedores')))) || (currentUser?.roles?.includes('Administrativo')))
                  ? true : false)
                : true}
              color={currentUser?.permisos?.includes('writeContrato') ?
                (v.row.fechaFirma &&
                  (((currentUser?.roles?.includes('Vendedor Externo') || (currentUser?.roles?.includes('Administrador de Cartera')))
                    || (currentUser?.roles?.includes('Ejecutivo de Cuentas') || (currentUser?.roles?.includes('Jefe Vendedores')))) || (currentUser?.roles?.includes('Administrativo')))
                  ? 'secondary' : 'info')
                : 'secondary'}
              onClick={() => setShowUploadForm(v.row)}
              icon={<GridAction
                label={'Cargar Doc.'}
                key={v.row.contratoId}
                Icon={FileUploadIcon}
              />}
            />
            <GridActionsCellItem
              key={v.row.contratoId + '-editarContratoGridAction'}
              disabled={currentUser?.permisos?.includes('writeContrato') ?
                (v.row.fechaFirma &&
                  (((currentUser?.roles?.includes('Vendedor Externo') || (currentUser?.roles?.includes('Administrador de Cartera')))
                    || (currentUser?.roles?.includes('Ejecutivo de Cuentas') || (currentUser?.roles?.includes('Jefe Vendedores')))) || (currentUser?.roles?.includes('Administrativo')))
                  ? true : false)
                : true}
              color={currentUser?.permisos?.includes('writeContrato') ?
                (v.row.fechaFirma &&
                  (((currentUser?.roles?.includes('Vendedor Externo') || (currentUser?.roles?.includes('Administrador de Cartera')))
                    || (currentUser?.roles?.includes('Ejecutivo de Cuentas') || (currentUser?.roles?.includes('Jefe Vendedores')))) || (currentUser?.roles?.includes('Administrativo')))
                  ? 'secondary' : 'info')
                : 'secondary'}
              onClick={() => {
                setContratoSeleccionado(v.row.contratoId); let contrato = (contratos || [])?.find(c => c.contratoId === v.row.contratoId);

                contrato = mapContratoToFormProps(contrato);
                contrato.fechaAplicacionDesde = new Date().valueOf();
                let socios = mapSociosToFormProps(contrato);
                let campanasContratos = mapCampanasToFormProps(contrato)

                setContratoParaEditar({ ...contrato });
                setSociosParaEditar([...socios]);
                setCampanasParaEditar([...campanasContratos])
                setShowEditarContratoForm(true);
              }}//handleEdit(v.row); }}
              icon={<GridAction
                label={'Editar'}
                key={v.row.contratoId}
                Icon={EditIcon}
              />}
            />
            <GridActionsCellItem
              key={v.row.contratoId + '-deleteContratoGridAction'}
              disabled={!(v.row.fechaFirma !== null && v.row.fechaPerfeccionamiento !== null) ? (currentUser?.permisos?.includes('writeContrato') ?
                ((v.row.fechaFirma !== null) &&
                  (((currentUser?.roles?.includes('Vendedor Externo') || (currentUser?.roles?.includes('Administrador de Cartera')))
                    || (currentUser?.roles?.includes('Ejecutivo de Cuentas') || (currentUser?.roles?.includes('Jefe Vendedores')))) || (currentUser?.roles?.includes('Administrativo')))
                  ? true : false)
                : true) : true}
              color={!(v.row.fechaFirma !== null && v.row.fechaPerfeccionamiento !== null) ? (currentUser?.permisos?.includes('writeContrato') ?
                ((v.row.fechaFirma !== null) &&
                  (((currentUser?.roles?.includes('Vendedor Externo') || (currentUser?.roles?.includes('Administrador de Cartera')))
                    || (currentUser?.roles?.includes('Ejecutivo de Cuentas') || (currentUser?.roles?.includes('Jefe Vendedores')))) || (currentUser?.roles?.includes('Administrativo')))
                  ? 'secondary' : 'danger')
                : 'secondary') : 'secondary'}
              onClick={() => { setShowDeleteContratoConfirmation(true); setContratoSeleccionado(v.row) }}
              icon={<GridAction
                label={'Eliminar'}
                key={v.row.contratoId}
                Icon={DeleteIcon}
              />}
            />
          </>
      }
    ];
    const FirmarContratoForm = (props) => {
      const [fechaFirma, setFechaFirma] = useState(Date.now())
      const firmarContratoSubmit = () => {
        setErroresFechaFirma("");
        if (!fechaFirma) {
          setErroresFechaFirma("Seleccione una fecha");
          return;
        }
        try {
          let newContrato = { contratoId: contratoSeleccionado.contratoId, fechaFirma: new Date(fechaFirma).setHours(0, 0, 0, 0).valueOf() };
          dispatch(firmarContrato(newContrato));
          setFirmarContratoModal(false);
        } catch (error) {
          console.error("error firmar contrato", error);
        }
      };
      return (<Dialog TransitionComponent={Grow}
        onClose={() => { setErroresFechaFirma(""); setFirmarContratoModal(false); }} open={firmarContratoModal}
        minWidth="md"
      >
        <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Firmar Contrato ID {contratoSeleccionado?.contratoId}:</DialogTitle>
        <DialogContent dividers>
          {!(currentUser?.roles?.includes('Admin')) && new Date().getMonth() !== new Date(parseInt(contratoSeleccionado?.fechaCreacion)).getMonth() ?
            <>
              <Grid container>
                <Grid item xs={12}>
                  <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <Typography>Solamente los administradores tienen permiso para firmar contratos en meses distintos al de su creación.</Typography>
                  </div>
                </Grid>
              </Grid>
            </>
            :
            <>
              <Grid container>
                <Grid item xs={12}>
                  <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Fecha"
                          inputFormat="DD/MM/YYYY"
                          minDate={dayjs().month()}
                          value={fechaFirma}
                          shouldDisableDate={(date) => currentUser?.roles?.includes('Admin') ? false : date.month() !== dayjs().month()}
                          onChange={(v) => setFechaFirma((v.valueOf()))}
                          renderInput={(params) => <TextField {...params} />}
                          slotProps={{
                            textField: {
                              required: true,
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sx={{ color: "error.main" }}>
                  <p style={{ marginLeft: "8px" }}>{erroresFechaFirma}</p>
                </Grid>
              </Grid>
            </>
          }
        </DialogContent>
        {!(currentUser?.roles?.includes('Admin')) && new Date().getMonth() !== new Date(parseInt(contratoSeleccionado?.fechaCreacion)).getMonth() ?
          <>
            <DialogActions style={{ marginTop: '10px' }}>
              <Button variant="contained" onClick={() => { setErroresFechaFirma(""); setFirmarContratoModal(false); }}>{"Aceptar"}</Button>
            </DialogActions>
          </>
          :
          <>
            <DialogActions style={{ marginTop: '10px' }}>
              <Button variant="outlined" onClick={() => { setErroresFechaFirma(""); setFirmarContratoModal(false); }} sx={{ fontWeight: "bold" }}>{"Cancelar"}</Button>
              <Button variant="contained" onClick={() => firmarContratoSubmit()} sx={{ marginRight: '5px', color: "white", fontWeight: "bold" }}>{"Aceptar"}</Button>
            </DialogActions>
          </>
        }
      </Dialog>)
    };
    const ModalPerfeccionamiento = (props) => {
      const [erroresPerfeccionamiento, setErroresPerfeccionamiento] = useState();
      const [fechaPerfeccionamiento, setFechaPerfeccionamiento] = useState(Date.now());

      function perfeccionarContrato() {
        setErroresPerfeccionamiento("");

        if (!fechaPerfeccionamiento) {
          setErroresPerfeccionamiento("Seleccione una fecha");
          return;
        }

        try {
          let newContrato = { contratoId: contratoSeleccionado.contratoId, fechaPerfeccionamiento: new Date(fechaPerfeccionamiento).setHours(0, 0, 0, 0).valueOf() };
          dispatch(firmarContrato(newContrato));
          setPerfeccionarContratoModal(false);
        } catch (error) {
          console.error("error firmar contrato", error);
        }
      }
      return (
        <Dialog
          TransitionComponent={Grow}
          onClose={() => { setPerfeccionarContratoModal(false); }} open={perfeccionarContratoModal}
          minWidth="sm"
        >
          <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Perfeccionar Contrato ID {contratoSeleccionado?.contratoId}:</DialogTitle>
          <Grid container>
            <DialogContent dividers>
              <Grid xs={12}>
                <div style={{ marginTop: '10px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Fecha"
                      inputFormat="MM/DD/YYYY"
                      value={fechaPerfeccionamiento}
                      onChange={(v) => setFechaPerfeccionamiento(v)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </div>

              </Grid>
              <Grid xs={12} sx={{ color: "error.main" }}>
                <p style={{ marginLeft: "8px" }}>{erroresPerfeccionamiento}</p>
              </Grid>
            </DialogContent>
          </Grid>
          <DialogActions style={{ marginTop: '10px' }}>
            <Button variant="outlined" onClick={() => { setPerfeccionarContratoModal(false); }}>{"Cancelar"}</Button>
            <Button variant="contained" onClick={() => perfeccionarContrato()} sx={{ marginRight: '5px' }}>{"Aceptar"}</Button>
          </DialogActions>
        </Dialog>
      )
    };
    const CargarArchivosForm = (props) => {
      const [newDocumentos, setNewDocumentos] = useState([]);
      const [formErrors, setFormErrors] = useState("");
      const removeDoc = (index) => setNewDocumentos([...newDocumentos.filter((x, i) => i !== index)]);
      const handleSubmit = () => {
        let newDocumentosAux = new FormData();
        newDocumentosAux.append("nombreTabla", 'Contratos');
        newDocumentosAux.append("refId", showUploadForm.contratoId);
        newDocumentos?.forEach(d => {
          newDocumentosAux.append('files', d);
        });
        try {
          const response = fetch((process.env.REACT_APP_BACKEND_URL + '/documentos'), {
            method: 'POST',
            body: newDocumentosAux,
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          if (response) {

            // Procesa la respuesta del servidor aquí
            dispatch(getContratosData())
            setShowUploadForm(false)
          } else {
            console.error('Error al subir el archivo');
            dispatch(getContratosData())
            setShowUploadForm(false)
          }
        } catch (error) {
          console.error('Error al subir el archivo:', error);
          dispatch(getContratosData())
          setShowUploadForm(false)
        }
        //dispatch(addDoc(newDocumentosAux)).catch(console.error)
      };
      const MyHeader = (state, previousDocument, nextDocument) => {
        state.lenguage = "es"

        if (!state.currentDocument || state.config?.header?.disableFileName) {
          return null;
        }
        return (
          <Grid container direction="row" sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid xs={12}>{state.currentDocument.fileName || ""}</Grid>
            <Grid xs={6} sx={{ paddingTop: '0.5rem' }}>Documento {state.currentFileNo + 1 || ""}</Grid>
            <Grid xs={6} sx={{ paddingBottom: '1rem' }}>
              <IconButton className="mb-3" variant="contained" color='danger' onClick={_ => removeDoc(state.currentFileNo)} children={<DeleteIcon />} />
              <IconButton sx={{ fontWeight: "bold", color: theme.palette.success.main }} onClick={previousDocument} disabled={state.currentFileNo === 0} children={<ArrowCircleLeftRounded />} />
              <IconButton sx={{ fontWeight: "bold", color: theme.palette.success.main }} onClick={nextDocument} disabled={state.currentFileNo >= state.documents.length - 1} children={<ArrowCircleRightRounded />} />
            </Grid>
          </Grid>
        );
      };

      return (
        <Dialog
          TransitionComponent={Grow}
          onClose={() => { setShowUploadForm(false); }} open={showUploadForm}
          fullWidth={'sm'}
        >
          <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Cargar Archivos para el contrato ID {showUploadForm?.contratoId}</DialogTitle>
          <Grid container>
            <DialogContent dividers>
              <Grid container direction="column" justifyContent="center" alignItems="center">
                <InputFile title={"Documentos " + newDocumentos?.length} multiple={true} docId={'documentos'} onChange={(e) => {
                  const filesArray = Array.from(e.target.files); // Convert FileList to array
                  setNewDocumentos(prevDocumentos => [...prevDocumentos, ...filesArray]);
                }} />
                <DocViewer
                  theme={{
                    primary: "#ffffff",
                    secondary: theme.palette.success.main,
                    tertiary: "#ffffff",
                    textPrimary: "#ffffff",
                    textSecondary: theme.palette.primary.dark,
                    textTertiary: theme.palette.primary.dark,
                    disableThemeScrollbar: false,
                  }}
                  config={{
                    header: {
                      overrideComponent: MyHeader,
                    },
                    csvDelimiter: ",", // "," as default,
                    pdfZoom: {
                      defaultZoom: 1.1, // 1 as default,
                      zoomJump: 0.2, // 0.1 as default,
                    },
                    pdfVerticalScrollByDefault: true, // false as default
                  }}
                  style={{ width: '20rem', height: '20rem' }}
                  documents={newDocumentos?.map(d => ({ uri: window.URL.createObjectURL(d), fileName: d.name }))}
                  pluginRenderers={DocViewerRenderers} />
              </Grid>
            </DialogContent>
          </Grid>
          <DialogActions style={{ marginTop: '10px' }}>
            <Button variant="outlined" onClick={() => { setShowUploadForm(false); }}>{"Cancelar"}</Button>
            <Button variant="contained" onClick={() => handleSubmit()} sx={{ marginRight: '5px' }}>{"Aceptar"}</Button>
          </DialogActions>
        </Dialog>
      )
    };
    const DeleteContratoConfirmation = (props) => {
      const [deletingContrato, setDeletingContrato] = useState(false); // Estado para controlar si la eliminación del contrato está en progreso

      function handleDelete() {
        setDeletingContrato(true); // Establecer que la eliminación del contrato está en progreso
        dispatch(deleteContrato([contratoSeleccionado?.contratoId]))
          .then(() => {
            setDeletingContrato(false); // Establecer que la eliminación del contrato ha terminado
            setShowDeleteContratoConfirmation(false); // Cerrar el modal
            dispatch(getContratosData())
            setContratoSeleccionado(false);
          })
          .catch(() => {
            setDeletingContrato(false); // Establecer que la eliminación del contrato ha terminado (incluso si falla)
          });
      };

      return (
        <Dialog
          onClose={() => { setShowDeleteContratoConfirmation(false); setContratoSeleccionado(false) }}
          open={showDeleteContratoConfirmation}
          minWidth="md"
          fullWidth
          TransitionComponent={Grow}
          keepMounted
        >
          <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Eliminar Contrato ID {contratoSeleccionado?.contratoId}:</DialogTitle>
          <DialogContent dividers>
            {deletingContrato ? ( // Si la eliminación del contrato está en progreso, mostrar "Eliminando contrato..."
              <Grid direction={'column'} sx={{
                display: 'flex',
                justifyContent: 'center', // Centra horizontalmente
                alignItems: 'center', // Centra verticalmente
                minHeight: '20vh', // Asegura que el contenedor ocupe toda la altura de la pantalla
              }}>
                <Typography children={'Eliminando contrato...'} />
                <ClipLoader
                  color={theme.palette.success.main}
                  loading={true}
                  size={30}
                  data-testid="loader"
                />
              </Grid>
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>
                    ¿Seguro quiere eliminar el contrato  ID {contratoSeleccionado?.contratoId} - {clasesContratos?.find(x => x.claseContratoId === contratoSeleccionado?.claseContratoId)?.descripcion}?
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography>
                    Esta acción no podrá deshacerse.
                  </Typography>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions style={{ marginTop: '10px' }}>
            <Button variant="outlined" disabled={deletingContrato} onClick={() => { setShowDeleteContratoConfirmation(false); setContratoSeleccionado(false) }} sx={{ fontWeight: "bold" }}>{"Cancelar"}</Button>
            <Button variant="contained" disabled={deletingContrato} onClick={() => handleDelete()} sx={{ marginRight: '5px', color: "white", fontWeight: "bold" }}>{"Aceptar"}</Button>
          </DialogActions>
        </Dialog>
      );
    };

    const DetallesContratoModal = (props) => {
      const CAC2Nominal = (montoCac, fecha) => montoCac * getIndiceAt(fecha, -2).cac;
      const [selectedTab, setSelectedTab] = useState(0);

      const inf = (useSelector(state => state?.contratos?.infoContrato) || {});
      const detalles = {
        claseContrato: (clasesContratos || [])?.find(x => parseInt(x.claseContratoId) === parseInt(inf?.contrato?.claseContratoId)),
        contrato: inf?.contrato,
        historia: inf?.historia,
        titularidades: inf?.titularidades, // (titularidades || [])?.filter(x => parseInt(x.contratoId) === parseInt(contratoSeleccionado)), //inf?.titularidades
        campanas: inf?.campanas
      };

      let catarataPagos = []
      //console.log('detalles', detalles, 'inf', inf)
      if (detalles == null) return null;
      detalles?.historia?.forEach(h => { if (h.subHistoria) catarataPagos?.push(h.subHistoria) });
      catarataPagos = catarataPagos.flat();
      /**
     * @param {types.EstadoContrato} estadoAnterior
     * @param {types.Operacion} operacion
     * @returns {Promise<{operacion:types.Operacion, estado:types.EstadoContrato}>}
     * Crea el estado 'i+1' a partir del estado y operaciones 'i' (puede crear y modificar el orden de las operaciones que siguen)
    */
      function handleDownload() {
        const datos = catarataPagos?.map((c) => [
          getFecha(c.subEstado?.fecha),
          c.subOperacion.tipo,
          c.subOperacion?.data?.cancelacionTotal ? 'Sí' : 'No',
          moneyFormat(CAC2Nominal(c.subOperacion?.data?.montoCAC, c.subEstado?.fecha)?.toFixed(2)),
          moneyFormat(CAC2Nominal(c.subOperacion?.data?.bonificacionCAC > 0.00 ? c.subOperacion?.data?.bonificacionCAC : 0.00, c.subEstado?.fecha)?.toFixed(2)),
          '',
          getFecha(c.subEstado?.indice.fecha),
          moneyFormat(c.subEstado?.indice.cac)

        ]);
        // Crear el libro de trabajo de Excel
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([
          [
            'Fecha Pago',
            'Tipo',
            'Cancelación',
            'Importe',
            'Bonificación',
            '',
            'Fecha Indice',
            'CAC',
          ],
          ...datos,
        ]);
        // Configurar el ancho de las columnas
        const columnWidths = [
          { wch: 15 }, // Ancho de la columna CBU
          { wch: 25 }, // Ancho de la columna Importe
          { wch: 15 }, // Ancho de la columna Partida
          { wch: 15 }, // Ancho de la columna Referencia
          { wch: 15 }, // Ancho de la columna Fecha Presentación
          { wch: 15 }, // Ancho de la columna Fecha Vencimiento
          { wch: 15 }, // Ancho de la columna Nombre Adherente
        ];
        worksheet['!cols'] = columnWidths;

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

        // Generar el archivo Excel
        const excelBuffer = XLSX.write(workbook, {
          type: 'array',
          bookType: 'xlsx',
        });

        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Contrato ID: ${inf?.contratoId} - ${detalles?.claseContrato?.codigo}.xlsx`;
        link.click();
        URL.revokeObjectURL(url);
      };
      const GeneralTab = (props) => {

        if (detalles?.historia == null) return null;
        const { estado, operacion } = _.last(detalles.historia)
        const valorContratoCAC = estado?.adelantoInicialAcumCAC + estado?.adelantoInicialBonifAcumCAC + estado?.ofertaLicitatoriaAcumCAC
          + estado?.ofertaLicitatoriaBonifAcumCAC + estado?.cuotaEsperaAcumCAC + estado?.cuotaEsperaBonifAcumCAC
          + estado?.primaAcumCAC + estado?.cuotaPrimaBonifAcumCAC + estado?.cuotaPosesionAcumCAC
          + estado?.adelantoRecurrenteAcumCAC + estado?.adelantoRecurrenteBonifAcumCAC + estado?.adelantoEspontaneoAcumCAC
          + estado?.adelantoEspontaneoBonifAcumCAC + estado?.refuerzoSemestralCuotaEsperaAcumCAC + estado?.refuerzoSemestralCuotaEsperaBonifAcumCAC
          + estado?.refuerzoSemestralAdelantoRecurrenteAcumCAC + estado?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC;
        const obligacionTotalMensual = estado.cuotaEsperaMesRestanteCAC + estado.cuotaEsperaMesAcumCAC + estado.cuotaPrimaMesRestanteCAC +
          estado.cuotaPrimaMesAcumCAC + estado.cuotaPrimaMesAcumCAC + estado.cuotaPosesionRestanteCAC + estado.cuotaPosesionAcumCAC +
          estado.adelantoRecurrenteMesRestanteCAC + estado.adelantoRecurrenteMesAcumCAC;
        const obligacionTotalMensualRefuerzos = estado.refuerzoSemestreCuotaEsperaRestanteCAC + estado.refuerzoSemestreCuotaEsperaAcumCAC +
          estado.refuerzoSemestreAdelantoRecurrenteRestanteCAC + estado.refuerzoSemestreAdelantoRecurrenteaAcumCAC
        const ContextHeader = () => {
          return (<>
            <Grid item xs={3} children={`Última actualización: ${new Date(estado.fecha)?.toLocaleDateString()}`} />
            <Grid item xs={3} children={`Última operación: '${operacion.tipo}'`} />
            <Grid item xs={2} children={`Puntos: ${estado?.puntos?.toFixed(2)}`} />
            <Grid item xs={2} children={`Índice CAC: ${(parseFloat(estado?.indice?.cac) / 100.00)?.toFixed(2)}`} />
            <Grid item xs={4} />
          </>)
        };

        const GridHeaders = ({ label }) => {
          const GridHeader = props => <Grid fontWeight={600} paddingLeft={'.1em'} item xs={props.xs} backgroundColor={theme.palette.success.main} color='white' children={props.children} />;

          return (<>
            <GridHeader xs={3} children={label} />
            <GridHeader xs={2.4} children={`Nominal`} />
            <GridHeader xs={1.8} children={`CAC`} />
            <GridHeader xs={1.8} children={`Cuotas Eq`} />
            <GridHeader xs={1.5} children={`M2`} />
            <GridHeader xs={1.5} children={`%GA`} />
          </>)
        };

        const GridRow = ({ label, valorCAC, style = {} }) => {
          const { cac, nominal, cuotasEq, m2, ga } = getConversionesCAC(valorCAC, estado.indice, detalles.claseContrato);
          const GridCell = (props) => <Grid item xs={props.xs} children={props.children} />;
          return (<>
            <GridCell xs={3} style={style} children={<Typography style={style} children={(label)} />} />
            <GridCell xs={2.4} children={<Typography style={style} children={(moneyFormat(nominal))} />} />
            <GridCell xs={1.8} children={<Typography style={style} children={(cac?.toFixed(3))} />} />
            <GridCell xs={1.8} children={<Typography style={style} children={(cuotasEq?.toFixed(3))} />} />
            <GridCell xs={1.5} children={<Typography style={style} children={(m2?.toFixed(3))} />} />
            <GridCell xs={1.5} children={<Typography style={style} children={('%' + (ga * 100)?.toFixed(3))} />} />
          </>)
        };

        return (<Grid container spacing={0}>
          <ContextHeader />

          <Grid item xs={12} />
          <GridHeaders label='General' />
          <Grid item xs={12} children={<Accordion>
            <AccordionSummary sx={{ padding: 0 }} children={<GridRow label={<Typography fontWeight={'bold'} sx={{ paddingLeft: '0.5rem' }} > Valor Total <ExpandMoreIcon sx={{ zoom: 0.6 }} /></Typography>} style={{ fontWeight: 'bold' }} valorCAC={valorContratoCAC} />} />
            <AccordionDetails sx={{ padding: 0 }} >
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adel Ini')} />} valorCAC={estado.adelantoInicialAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adel Ini Bonif')} />} valorCAC={estado.adelantoInicialBonifAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Cuota Espera')} />} valorCAC={estado.cuotaEsperaAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Cuota Espera Bonif')} />} valorCAC={estado.cuotaEsperaBonifAcumCAC} />} />

              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Recurrente')} />} valorCAC={estado.adelantoRecurrenteAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Recurrente Bonif')} />} valorCAC={estado.adelantoRecurrenteBonifAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Espontaneo')} />} valorCAC={estado.adelantoEspontaneoAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Espontaneo Bonif')} />} valorCAC={estado.adelantoEspontaneoBonifAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Espera')} />} valorCAC={estado.refuerzoSemestralCuotaEsperaAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Espera Bonif')} />} valorCAC={estado.refuerzoSemestralCuotaEsperaBonifAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Recurrente')} />} valorCAC={estado.refuerzoSemestralAdelantoRecurrenteAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Recurrente Bonif')} />} valorCAC={estado.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Prima Acum')} />} valorCAC={estado.primaAcumCAC} />} />
              {/* <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem'}} children={('Prima Acum Bonif')} />} valorCAC={estado.cuotaPrimaBonifAcumCAC} />} /> */}
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Cuota Posesion Acumulado')} />} valorCAC={estado.cuotaPosesionAcumCAC} />} />
              <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ofer Lic')} />} valorCAC={estado.ofertaLicitatoriaAcumCAC} />} />
              {/* <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem'}} children={('Ofer Lic Bonif')} />} valorCAC={estado.ofertaLicitatoriaBonifAcumCAC} />} /> */}
            </AccordionDetails>
          </Accordion>} />
          <Grid item xs={12} />

          <GridRow label='Capital Licitatorio' valorCAC={estado.capitalLicitatorioCAC} />
          <GridRow label='Prima Restante' valorCAC={estado.primaRestanteCAC} />
          <GridRow label='Mora' valorCAC={estado.moraCAC} />
          <GridRow label='Intereses Mora' valorCAC={estado.interesesMoraCAC} />
          { }
          <Grid item xs={12} />
          <GridHeaders label='Pagos Generales' />
          <GridRow label='Adelanto Inicial Restante' valorCAC={estado.adelantoInicialRestanteCAC} />
          <GridRow label='Adelanto Inicial Acumulado' valorCAC={estado.adelantoInicialAcumCAC} />
          <GridRow label='Oferta Licitatoria Restante' valorCAC={estado.ofertaLicitatoriaRestanteCAC} />
          <GridRow label='Oferta Licitatoria Acumulado' valorCAC={estado.ofertaLicitatoriaAcumCAC} />

          <Grid item xs={12} />
          <GridHeaders label='Pagos Mes' />
          <GridRow label='Obligación Mensual Total' valorCAC={obligacionTotalMensual} />
          <GridRow label='Cuota Espera Mes Restante' valorCAC={estado.cuotaEsperaMesRestanteCAC} />
          <GridRow label='Cuota Espera Mes Acumulado' valorCAC={estado.cuotaEsperaMesAcumCAC} />
          <GridRow label='Cuota Prima Mes Restante' valorCAC={estado.cuotaPrimaMesRestanteCAC} />
          <GridRow label='Cuota Prima Mes Acumulado' valorCAC={estado.cuotaPrimaMesAcumCAC} />
          <GridRow label='Cuota Posesion Mes Restante' valorCAC={estado.cuotaPosesionRestanteCAC} />
          <GridRow label='Cuota Posesion Mes Acumulado' valorCAC={estado.cuotaPosesionAcumCAC} />
          <GridRow label='Adelanto Recurrente Mes Restante' valorCAC={estado.adelantoRecurrenteMesRestanteCAC} />
          <GridRow label='Adelanto Recurrente Mes Acumulado' valorCAC={estado.adelantoRecurrenteMesAcumCAC} />
          <GridRow label='Adelanto Espontaneo Mes Acumulado' valorCAC={estado.adelantoEspontaneoMesAcumCAC} />

          <Grid item xs={12} />
          <GridHeaders label='Refuerzos Semestrales' />
          <GridRow label='Obligación Refuerzos Mensual Total' valorCAC={obligacionTotalMensualRefuerzos} />
          <GridRow label='Ref. Sem. C. Espera Mes Restante' valorCAC={estado.refuerzoSemestreCuotaEsperaRestanteCAC} />
          <GridRow label='Ref. Sem. C. Espera Mes Acumulado' valorCAC={estado.refuerzoSemestreCuotaEsperaAcumCAC} />
          <GridRow label='Ref. Sem. Adel. Recurrente Mes Restante' valorCAC={estado.refuerzoSemestreAdelantoRecurrenteRestanteCAC} />
          <GridRow label='Ref. Sem. Adel. Recurrente Mes Acumulado' valorCAC={estado.refuerzoSemestreAdelantoRecurrenteaAcumCAC} />
        </Grid>)
      };
      const HistorialTab = props => {
        const historia = detalles?.historia
        const sortedEstados = historia ? [...historia].sort((a, b) => b.operacion.fecha - a.operacion.fecha) : [];
        const Operacion = (props) => {

          const PagosActivablesButton = ({ pagosActivables }) => {
            return (
              <div>
                <MuiTooltip title={<div style={{ padding: '1rem', paddingTop: '0.5rem' }}>
                  <Typography sx={{ p: 1, fontWeight: 700 }}>{`Pagos Activables (${pagosActivables?.length ?? 0}):`}</Typography>
                  {pagosActivables?.map((c, i) =>
                    <Typography key={'pagosActivables' + i}>
                      {`* Activado: ${c.activado ? 'SI' : 'NO'} - Monto: ${c.activado ? moneyFormat(c.montoNominal) : '$'} - Fecha: ${c.activado ? new Date(parseInt(c.fecha)).toLocaleDateString() : '-/-/-'}`}
                    </Typography>)}
                </div>}>
                  <PaidIcon color={pagosActivables?.length > 0 ? "info" : "secondary"} />
                </MuiTooltip>
              </div>
            );
          };

          const CampanasActivasButton = ({ campanasActivas }) => {
            return (
              <div>
                <MuiTooltip title={<div style={{ padding: '1rem', paddingTop: '0.5rem' }}>
                  <Typography sx={{ p: 1, fontWeight: 700 }}>{`Campañas Activas (${campanasActivas?.length ?? 0}):`}</Typography>
                  {campanasActivas?.map((c, i) => <Typography key={'TipoCampanaActivaRow' + i}>{`* ${tiposCampana?.find(tc => parseInt(c.tipoCampanaId) === parseInt(tc.tipoCampanaId))?.nombre} %${parseInt(100 * c?.parametros?.porcentaje)}`}</Typography>)}
                </div>}>
                  <CampaignIcon color={campanasActivas?.length > 0 ? "info" : "secondary"} />
                </MuiTooltip>

              </div>
            );
          };

          const TitularidadesButton = ({ titularidadesActuales }) => {
            return (
              <div>
                <MuiTooltip title={<div style={{ padding: '1rem', paddingTop: '0.5rem' }}>
                  <Typography sx={{ p: 1, fontWeight: 700 }}>{`Titularidades (${titularidadesActuales?.length ?? 0}):`}</Typography>
                  {titularidadesActuales?.map((t, i) => {
                    const persona = personas.find(p => p.personaId === t.personaId);
                    return <Typography key={i} children={`* ${persona.nombre}, ${persona.apellido}`} />
                  })}
                </div>}>
                  <SafetyDividerIcon color={titularidadesActuales?.length > 0 ? "info" : "secondary"} />
                </MuiTooltip>

              </div>
            );
          };

          const ContratoActualButton = ({ contratoActual }) => {
            let {
              fechaCreacion,
              fechaEdicion,
              fechaAplicacionDesde,
              fechaAplicacionHasta,
              perPrimaAdjudicacion,
              adelantoInicialNominal,
              adelantoRecurrenteCAC,
              mesRefuerzoSemestral1,
              mesRefuerzoSemestral2,
              editorId,
              contratoPrincipalId,
              creadorId,
              claseContratoId
            } = contratoActual;
            let claseContrato = (clasesContratos || [])?.find(c => c.claseContratoId === claseContratoId)?.codigo
            return (
              <div>
                <MuiTooltip title={<div style={{ padding: '1rem', paddingTop: '0.5rem' }}>
                  <Typography sx={{ p: 1, fontWeight: 700 }}>{`Parámetros Contrato:`}</Typography>
                  <Typography children={`* Creación : ${new Date(parseInt(fechaCreacion)).toLocaleString()}`} />
                  <Typography children={`* Edición : ${new Date(parseInt(fechaEdicion)).toLocaleString()}`} />
                  <Typography children={`* Desde : ${new Date(parseInt(fechaAplicacionDesde)).toLocaleString()}`} />
                  <Typography children={`* Hasta : ${new Date(parseInt(fechaAplicacionHasta)).toLocaleString()}`} />
                  <Typography children={`* Prima : %${(perPrimaAdjudicacion * 100)?.toFixed(2)}`} />
                  <Typography children={`* Tipología : ${claseContrato}`} />
                  <Typography children={`* Adel Inic Nom : ${moneyFormat(parseInt(adelantoInicialNominal))}`} />
                  <Typography children={`* Adel Rec CAC : ${adelantoRecurrenteCAC.toFixed(2)}`} />
                  <Typography children={`* Refuerzo : ${mesRefuerzoSemestral1 || mesRefuerzoSemestral2 ? 'SÍ' : 'NO'}`} />
                  <Typography children={`* ID Creador : ${creadorId}`} />
                  <Typography children={`* ID Editor : ${editorId}`} />
                  <Typography children={`* ID Principal : ${contratoPrincipalId}`} />
                </div>}>
                  <ArticleIcon color={"info"} />
                </MuiTooltip>

              </div>
            );
          };

          const NoSubHistoriaRow = ({ operacion, estado, campanasActivas, titularidadesActuales, contratoActual, subOperacion = false, claseContratoActual }) => {
            const valorContratoCAC = estado?.adelantoInicialAcumCAC + estado?.adelantoInicialBonifAcumCAC + estado?.ofertaLicitatoriaAcumCAC
              + estado?.ofertaLicitatoriaBonifAcumCAC + estado?.cuotaEsperaAcumCAC + estado?.cuotaEsperaBonifAcumCAC
              + estado?.primaAcumCAC + estado?.cuotaPrimaBonifAcumCAC + estado?.cuotaPosesionAcumCAC
              + estado?.adelantoRecurrenteAcumCAC + estado?.adelantoRecurrenteBonifAcumCAC + estado?.adelantoEspontaneoAcumCAC
              + estado?.adelantoEspontaneoBonifAcumCAC + estado?.refuerzoSemestralCuotaEsperaAcumCAC + estado?.refuerzoSemestralCuotaEsperaBonifAcumCAC
              + estado?.refuerzoSemestralAdelantoRecurrenteAcumCAC + estado?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC;
            const obligacionTotalMensual = estado.cuotaEsperaMesRestanteCAC + estado.cuotaEsperaMesAcumCAC + estado.cuotaPrimaMesRestanteCAC +
              estado.cuotaPrimaMesAcumCAC + estado.cuotaPrimaMesAcumCAC + estado.cuotaPosesionRestanteCAC + estado.cuotaPosesionAcumCAC +
              estado.adelantoRecurrenteMesRestanteCAC + estado.adelantoRecurrenteMesAcumCAC;
            const obligacionTotalMensualRefuerzos = estado.refuerzoSemestreCuotaEsperaRestanteCAC + estado.refuerzoSemestreCuotaEsperaAcumCAC +
              estado.refuerzoSemestreAdelantoRecurrenteRestanteCAC + estado.refuerzoSemestreAdelantoRecurrenteaAcumCAC
            const OperacionInfo = () => {
              let str = ``;
              switch (operacion.tipo) {
                case 'Creación':
                  str += `Prima: ${(operacion.data.perPrimaAdjudicacion * 100)?.toFixed(0)}% - `;
                  str += `Adel Inic: ${moneyFormat(operacion.data.adelantoInicialNominal)} - `;
                  str += `Adel Rec CAC: ${operacion.data.adelantoRecurrenteCAC.toFixed(2)} - `;
                  str += `Ref Sem: ${operacion.data.mesRefuerzoSemestral1 ? 'SI' : 'NO'} - `;
                  break;
                case 'Nuevo Mes':
                  str += `ValorCAC: ${(valorContratoCAC).toFixed(3)} - Puntos: ${estado.puntos.toFixed(2)} `;
                  break;
                case 'Pago':
                  str += `Nominal: ${moneyFormat(operacion.data.montoNominal)}  `;
                  str += `Fecha Carga: ${new Date(parseInt(operacion.data.fecha))?.toLocaleDateString()}  `;
                  break;
                case 'Pago Activado':
                  str += `Nominal: ${moneyFormat(operacion.data.montoNominal)}  `;
                  str += `CAC: ${moneyFormat(operacion.data.montoCAC)}  `;
                  str += `Fecha Carga: ${new Date(parseInt(operacion.data.fecha))?.toLocaleDateString()}  `;
                  str += `Tipo: ${operacion.data.descripcion}`;

                  break;
                case 'Pago En Espera':
                  str += `Nominal: ${moneyFormat(operacion.data.montoNominal)}  `;
                  str += `Fecha Carga: ${new Date(parseInt(operacion.data.fechaValor))?.toLocaleDateString()}  `;
                  str += `Tipo: ${operacion.data.descripcion}`;

                  break;
                case 'Inicio Campana':
                  str += tiposCampana?.find(x => x.tipoCampanaId === operacion.data.tipoCampanaId)?.nombre + ' ';
                  str += ` %${parseInt(100 * operacion.data?.parametros?.porcentaje)}`;
                  break;
                case 'Fin Campana':
                  str += tiposCampana?.find(x => x.tipoCampanaId === operacion.data.tipoCampanaId)?.nombre + ' ';
                  str += ` %${parseInt(100 * operacion.data?.parametros?.porcentaje)}`;
                  break;

                case 'Cambio de Tipología':
                  str += `ValorCAC: ${(valorContratoCAC).toFixed(3)} - Puntos: ${estado.puntos.toFixed(2)} - Tipología Actual: ${detalles?.claseContrato.codigo} `;
                  break;
                default:
                  str = ''
                  break;
              }

              return <Typography fontWeight={500} children={str} />;
            };

            const DetallesOp = (props) => {
              const ContextHeader = () => {
                return (<>
                  <Grid item xs={3} children={`Última actualización: ${new Date(estado.fecha)?.toLocaleDateString()}`} />
                  <Grid item xs={3} children={`Última operación: '${operacion.tipo}'`} />
                  <Grid item xs={2} children={`Puntos: ${estado?.puntos?.toFixed(2)}`} />
                  <Grid item xs={2} children={`Índice CAC: ${(parseFloat(estado?.indice?.cac) / 100.00)?.toFixed(2)}`} />
                  <Grid item xs={4} />
                </>)
              };

              const GridHeaders = ({ label }) => {
                const GridHeader = props => <Grid fontWeight={600} paddingLeft={'.1em'} item xs={props.xs} backgroundColor={theme.palette.success.main} color='white' children={props.children} />;

                return (<>
                  <GridHeader xs={3} children={label} />
                  <GridHeader xs={2.4} children={`Nominal`} />
                  <GridHeader xs={1.8} children={`CAC`} />
                  <GridHeader xs={1.8} children={`Cuotas Eq`} />
                  <GridHeader xs={1.5} children={`M2`} />
                  <GridHeader xs={1.5} children={`%GA`} />
                </>)
              };

              const GridRow = ({ label, valorCAC, style = {} }) => {
                const { cac, nominal, cuotasEq, m2, ga } = getConversionesCAC(valorCAC, estado.indice, detalles.claseContrato);
                const GridCell = (props) => <Grid item xs={props.xs} children={props.children} />;
                return (<>
                  <GridCell xs={3} style={style} children={<Typography style={style} children={(label)} />} />
                  <GridCell xs={2.4} children={<Typography style={style} children={(moneyFormat(nominal))} />} />
                  <GridCell xs={1.8} children={<Typography style={style} children={(cac?.toFixed(3))} />} />
                  <GridCell xs={1.8} children={<Typography style={style} children={(cuotasEq?.toFixed(3))} />} />
                  <GridCell xs={1.5} children={<Typography style={style} children={(m2?.toFixed(3))} />} />
                  <GridCell xs={1.5} children={<Typography style={style} children={('%' + (ga * 100)?.toFixed(3))} />} />
                </>)
              };

              return (<Grid container spacing={0}>
                <ContextHeader />

                <Grid item xs={12} />
                <GridHeaders label='General' />
                <Grid item xs={12} children={<Accordion sx={{ backgroundColor: '#e8e8e8' }}>
                  <AccordionSummary sx={{ padding: 0 }} children={<GridRow label={<Typography fontWeight={'bold'} sx={{ paddingLeft: '0.5rem' }} > Valor Total <ExpandMoreIcon sx={{ zoom: 0.6 }} /></Typography>} style={{ fontWeight: 'bold' }} valorCAC={valorContratoCAC} />} />
                  <AccordionDetails sx={{ padding: 0 }} >
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adel Ini')} />} valorCAC={estado.adelantoInicialAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adel Ini Bonif')} />} valorCAC={estado.adelantoInicialBonifAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Cuota Espera')} />} valorCAC={estado.cuotaEsperaAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Cuota Espera Bonif')} />} valorCAC={estado.cuotaEsperaBonifAcumCAC} />} />

                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Recurrente')} />} valorCAC={estado.adelantoRecurrenteAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Recurrente Bonif')} />} valorCAC={estado.adelantoRecurrenteBonifAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Espontaneo')} />} valorCAC={estado.adelantoEspontaneoAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Espontaneo Bonif')} />} valorCAC={estado.adelantoEspontaneoBonifAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Espera')} />} valorCAC={estado.refuerzoSemestralCuotaEsperaAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Espera Bonif')} />} valorCAC={estado.refuerzoSemestralCuotaEsperaBonifAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Recurrente')} />} valorCAC={estado.refuerzoSemestralAdelantoRecurrenteAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Recurrente Bonif')} />} valorCAC={estado.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Prima Acum')} />} valorCAC={estado.primaAcumCAC} />} />
                    {/* <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem'}} children={('Prima Acum Bonif')} />} valorCAC={estado.cuotaPrimaBonifAcumCAC} />} /> */}
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Cuota Posesion Acumulado')} />} valorCAC={estado.cuotaPosesionAcumCAC} />} />
                    <Grid conteiner rowSpacing={0} sx={{
                      display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                      width: "100%"
                    }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ofer Lic')} />} valorCAC={estado.ofertaLicitatoriaAcumCAC} />} />
                    {/* <Grid conteiner rowSpacing={0} sx={{
                display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                width: "100%"
              }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem'}} children={('Ofer Lic Bonif')} />} valorCAC={estado.ofertaLicitatoriaBonifAcumCAC} />} /> */}
                  </AccordionDetails>
                </Accordion>} />
                <GridRow label='Capital Licitatorio' valorCAC={estado.capitalLicitatorioCAC} />
                <GridRow label='Prima Restante' valorCAC={estado.primaRestanteCAC} />
                <GridRow label='Mora' valorCAC={estado.moraCAC} />
                <GridRow label='Intereses Mora' valorCAC={estado.interesesMoraCAC} />

                <Grid item xs={12} />
                <GridHeaders label='Pagos Generales' />
                <GridRow label='Adelanto Inicial Restante' valorCAC={estado.adelantoInicialRestanteCAC} />
                <GridRow label='Adelanto Inicial Acumulado' valorCAC={estado.adelantoInicialAcumCAC} />
                <GridRow label='Oferta Licitatoria Restante' valorCAC={estado.ofertaLicitatoriaRestanteCAC} />
                <GridRow label='Oferta Licitatoria Acumulado' valorCAC={estado.ofertaLicitatoriaAcumCAC} />

                <Grid item xs={12} />
                <GridHeaders label='Pagos Mes' />
                <GridRow label='Obligación Mensual Total' valorCAC={obligacionTotalMensual} />
                <GridRow label='Cuota Ahorro Mes Restante' valorCAC={estado.cuotaEsperaMesRestanteCAC} />
                <GridRow label='Cuota Ahorro Mes Acumulado' valorCAC={estado.cuotaEsperaMesAcumCAC} />
                <GridRow label='Cuota Prima Restante' valorCAC={estado.cuotaPrimaMesRestanteCAC} />
                <GridRow label='Cuota Prima Acumulado' valorCAC={estado.cuotaPrimaMesAcumCAC} />
                <GridRow label='Cuota Posesion Restante' valorCAC={estado.cuotaPosesionRestanteCAC} />
                <GridRow label='Cuota Posesion Acumulado' valorCAC={estado.cuotaPosesionAcumCAC} />
                <GridRow label='Adelanto Prepactado Mes Restante' valorCAC={estado.adelantoRecurrenteMesRestanteCAC} />
                <GridRow label='Adelanto Prepactado Mes Acumulado' valorCAC={estado.adelantoRecurrenteMesAcumCAC} />
                <GridRow label='Adelanto Espontaneo Mes Acumulado' valorCAC={estado.adelantoEspontaneoMesAcumCAC} />

                <Grid item xs={12} />
                <GridHeaders label='Refuerzos Semestrales' />
                <GridRow label='Obligación Refuerzos Mensual Total' valorCAC={obligacionTotalMensualRefuerzos} />
                <GridRow label='Ref. Sem. C. Ahorro Restante' valorCAC={estado.refuerzoSemestreCuotaEsperaRestanteCAC} />
                <GridRow label='Ref. Sem. C. Ahorro Acumulado' valorCAC={estado.refuerzoSemestreCuotaEsperaAcumCAC} />
                <GridRow label='Ref. Sem. Adel. Prepactado Restante' valorCAC={estado.refuerzoSemestreAdelantoRecurrenteRestanteCAC} />
                <GridRow label='Ref. Sem. Adel. Prepactado Acumulado' valorCAC={estado.refuerzoSemestreAdelantoRecurrenteaAcumCAC} />
              </Grid>)
            };

            const { pagosActivables } = estado;

            return <Accordion sx={{ backgroundColor: subOperacion ? '#f5f5f5' : '#e8e8e8', marginTop: '.75em' }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                <Grid container spacing={0}>
                  <Grid item xs={2} children={<Typography fontWeight={600} children={operacion.tipo} />} />
                  <Grid item xs={6} children={<OperacionInfo />} />
                  <Grid item xs={2} children={<Typography fontWeight={500} children={new Date(operacion.fecha).toLocaleString()} />} />
                  <Grid item xs={0.5} children={<PagosActivablesButton pagosActivables={pagosActivables} />} />
                  <Grid item xs={0.5} children={<CampanasActivasButton campanasActivas={campanasActivas} />} />
                  <Grid item xs={0.5} children={<TitularidadesButton titularidadesActuales={titularidadesActuales} />} />
                  <Grid item xs={0.5} children={<ContratoActualButton contratoActual={contratoActual} />} />
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <DetallesOp />
              </AccordionDetails>
            </Accordion>
          };

          const SubHistoriaRow = ({ operacion, estado, campanasActivas, subHistoria, titularidadesActuales, contratoActual, claseContratoActual }) => {
            const valorContratoCAC = estado?.adelantoInicialAcumCAC + estado?.adelantoInicialBonifAcumCAC + estado?.ofertaLicitatoriaAcumCAC
              + estado?.ofertaLicitatoriaBonifAcumCAC + estado?.cuotaEsperaAcumCAC + estado?.cuotaEsperaBonifAcumCAC
              + estado?.primaAcumCAC + estado?.cuotaPrimaBonifAcumCAC + estado?.cuotaPosesionAcumCAC
              + estado?.adelantoRecurrenteAcumCAC + estado?.adelantoRecurrenteBonifAcumCAC + estado?.adelantoEspontaneoAcumCAC
              + estado?.adelantoEspontaneoBonifAcumCAC + estado?.refuerzoSemestralCuotaEsperaAcumCAC + estado?.refuerzoSemestralCuotaEsperaBonifAcumCAC
              + estado?.refuerzoSemestralAdelantoRecurrenteAcumCAC + estado?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC;
            const obligacionTotalMensual = estado.cuotaEsperaMesRestanteCAC + estado.cuotaEsperaMesAcumCAC + estado.cuotaPrimaMesRestanteCAC +
              estado.cuotaPrimaMesAcumCAC + estado.cuotaPrimaMesAcumCAC + estado.cuotaPosesionRestanteCAC + estado.cuotaPosesionAcumCAC +
              estado.adelantoRecurrenteMesRestanteCAC + estado.adelantoRecurrenteMesAcumCAC;
            const obligacionTotalMensualRefuerzos = estado.refuerzoSemestreCuotaEsperaRestanteCAC + estado.refuerzoSemestreCuotaEsperaAcumCAC +
              estado.refuerzoSemestreAdelantoRecurrenteRestanteCAC + estado.refuerzoSemestreAdelantoRecurrenteaAcumCAC
            const SubRow = ({ subOperacion, subEstado, subSubHistoria }) => {

              const OperacionInfo = ({ subOperacion, subEstado }) => {
                let str = ``;
                switch (subOperacion.tipo) {
                  case 'Creación':
                    str += `Prima: ${(subOperacion.data.perPrimaAdjudicacion * 100)?.toFixed(0)}% - `;
                    str += `Adel Inic: ${moneyFormat(subOperacion.data.adelantoInicialNominal)} - `;
                    str += `Adel Rec CAC: ${subOperacion.data.adelantoRecurrenteCAC.toFixed(2)} - `;
                    str += `Ref Sem: ${subOperacion.data.mesRefuerzoSemestral1 ? 'SI' : 'NO'} - `;
                    break;
                  case 'Nuevo Mes':
                    str = ''
                    break;
                  case 'Perfeccionamiento':
                    str = ''
                    break;
                  case 'Puntos':
                    str += `Puntos: ${subOperacion.data.puntos} | Puntos Totales: ${(subEstado?.puntos)?.toFixed(2)}  `;
                    break;
                  case 'Pago Activado':
                    str += `Nominal: ${moneyFormat(subOperacion.data.montoNominal)}  `;
                    str += `CAC: ${moneyFormat(subOperacion.data.montoCAC)}  `;
                    str += `Fecha Carga: ${new Date(parseInt(subOperacion.data.fecha))?.toLocaleDateString()}  `;
                    str += `Tipo: $subOperacion.data.descripcion}`;

                    break;
                  case 'Pago En Espera':
                    str += `Nominal: ${moneyFormat(subOperacion.data.montoNominal)}  `;
                    str += `Fecha Carga: ${new Date(parseInt(subOperacion.data.fechaValor))?.toLocaleDateString()}  `;
                    str += `Tipo: ${subOperacion.data.descripcion}`;

                    break;
                  case 'Inicio Campana':
                    let nombreCampana = tiposCampana?.find(x => x.tipoCampanaId === subOperacion.data.tipoCampanaId)?.nombre
                    str += nombreCampana + ' ';
                    str += (nombreCampana === 'Cambio de Tipología' ? ` - Adel Rec Límite CAC: ${(subOperacion.data?.parametros?.bonifAdelantoEspontaneoPermitido).toFixed(2)}` : ` %${parseInt(100 * subOperacion.data?.parametros?.porcentaje)}`);
                    break;
                  case 'Fin Campana':
                    str += tiposCampana?.find(x => x.tipoCampanaId === subOperacion.data.tipoCampanaId)?.nombre + ' ';
                    str += ` %${parseInt(100 * subOperacion.data?.parametros?.porcentaje)}`;
                    break;
                  case 'Cambio de Tipología':
                    str = ''
                    break;
                  case 'Pago':
                    str += `Nominal: ${moneyFormat(subOperacion.data.montoNominal)} - `;
                    str += `CAC: ${(subOperacion.data.montoNominal / subEstado?.indice?.cac)?.toFixed(2)} - `;
                    str += `Fecha Carga: ${new Date(parseInt(subOperacion.data.fecha))?.toLocaleDateString()} - `;
                    break;
                  case 'Pago Activado':
                    str += `Nominal: ${moneyFormat(subOperacion.data.montoNominal)}  `;
                    str += `CAC: ${(subOperacion.data.montoNominal / subEstado?.indice?.cac)?.toFixed(2)} - `;
                    str += `Fecha Valor: ${new Date(parseInt(subOperacion.data.fecha))?.toLocaleDateString()}  `;
                    str += `Tipo: ${subOperacion.data.descripcion}`;
                    break;
                  case 'Pago En Espera':
                    str += `Nominal: ${moneyFormat(subOperacion.data.montoNominal)}  `;
                    str += `CAC: ${(subOperacion.data.montoNominal / subEstado?.indice?.cac)?.toFixed(2)} - `;
                    str += `Fecha Carga: ${new Date(parseInt(subOperacion.data.fechaValor))?.toLocaleDateString()}  `;
                    str += `Tipo: ${subOperacion.data.descripcion}`;
                    break;
                  default:
                    str += ` Nominal: ${moneyFormat(subOperacion?.data?.montoCAC * subEstado?.indice.cac)} `;
                    str += ` | CAC: ${(subOperacion?.data?.montoCAC)?.toFixed(2)} `;
                    str += ` | Bonificación : ${moneyFormat(subOperacion?.data?.bonificacionCAC * subEstado?.indice.cac)} (+${(100 * subOperacion?.data?.bonificacionCAC / subOperacion?.data?.montoCAC)?.toFixed(2)}%)`;
                    str += ` | Cancelación: ${(subOperacion?.data?.cancelacionTotal == null ? '-' : (subOperacion?.data?.cancelacionTotal ? 'SI' : 'NO'))} `;
                    str += ` | RestanteCAC: ${(subOperacion?.data?.pagoRestanteCAC)?.toFixed(4)} `;
                    break;
                }
                return <Typography fontWeight={500} children={str} />;
              };
              const DetallesOp = ({ subEstado, subOperacion }) => {
                const valorContratoCAC = subEstado?.adelantoInicialAcumCAC + subEstado?.adelantoInicialBonifAcumCAC + subEstado?.ofertaLicitatoriaAcumCAC
                  + subEstado?.ofertaLicitatoriaBonifAcumCAC + subEstado?.cuotaEsperaAcumCAC + subEstado?.cuotaEsperaBonifAcumCAC
                  + subEstado?.primaAcumCAC + subEstado?.cuotaPrimaBonifAcumCAC + subEstado?.cuotaPosesionAcumCAC
                  + subEstado?.adelantoRecurrenteAcumCAC + subEstado?.adelantoRecurrenteBonifAcumCAC + subEstado?.adelantoEspontaneoAcumCAC
                  + subEstado?.adelantoEspontaneoBonifAcumCAC + subEstado?.refuerzoSemestralCuotaEsperaAcumCAC + subEstado?.refuerzoSemestralCuotaEsperaBonifAcumCAC
                  + subEstado?.refuerzoSemestralAdelantoRecurrenteAcumCAC + subEstado?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC;
                const ContextHeader = () => {
                  return (<>
                    <Grid item xs={3} children={`Última actualización: ${new Date(subEstado?.fecha)?.toLocaleDateString()}`} />
                    <Grid item xs={3} children={`Última operación: '${subOperacion?.tipo}'`} />
                    <Grid item xs={2} children={`Puntos: ${subEstado?.puntos?.toFixed(2)}`} />
                    <Grid item xs={2} children={`Índice CAC: ${(parseFloat(subEstado?.indice?.cac) / 100.00)?.toFixed(2)}`} />
                    <Grid item xs={4} />
                  </>)
                };

                const GridHeaders = ({ label }) => {
                  const GridHeader = props => <Grid fontWeight={600} paddingLeft={'.1em'} item xs={props.xs} backgroundColor={theme.palette.success.main} color='white' children={props.children} />;

                  return (<>
                    <GridHeader xs={3} children={label} />
                    <GridHeader xs={2.4} children={`Nominal`} />
                    <GridHeader xs={1.8} children={`CAC`} />
                    <GridHeader xs={1.8} children={`Cuotas Eq`} />
                    <GridHeader xs={1.5} children={`M2`} />
                    <GridHeader xs={1.5} children={`%GA`} />
                  </>)
                };

                const GridRow = ({ label, valorCAC, style = {} }) => {
                  const { cac, nominal, cuotasEq, m2, ga } = getConversionesCAC(valorCAC, estado.indice, detalles.claseContrato);
                  const GridCell = (props) => <Grid item xs={props.xs} children={props.children} />;
                  return (<>
                    <GridCell xs={3} style={style} children={<Typography style={style} children={(label)} />} />
                    <GridCell xs={2.4} children={<Typography style={style} children={(moneyFormat(nominal))} />} />
                    <GridCell xs={1.8} children={<Typography style={style} children={(cac?.toFixed(3))} />} />
                    <GridCell xs={1.8} children={<Typography style={style} children={(cuotasEq?.toFixed(3))} />} />
                    <GridCell xs={1.5} children={<Typography style={style} children={(m2?.toFixed(3))} />} />
                    <GridCell xs={1.5} children={<Typography style={style} children={('%' + (ga * 100)?.toFixed(3))} />} />
                  </>)
                };

                return (<Grid container spacing={0}>
                  <ContextHeader />

                  <Grid item xs={12} />
                  <GridHeaders label='General' />
                  <Grid item xs={12} children={<Accordion sx={{ backgroundColor: subSubHistoria ? '#e8e8e8' : '#f5f5f5' }}>
                    <AccordionSummary sx={{ padding: 0 }} children={<GridRow label={<Typography fontWeight={'bold'} sx={{ paddingLeft: '0.5rem' }} > Valor Total <ExpandMoreIcon sx={{ zoom: 0.6 }} /></Typography>} style={{ fontWeight: 'bold' }} valorCAC={valorContratoCAC} />} />
                    <AccordionDetails sx={{ padding: 0 }} >
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adel Ini')} />} valorCAC={subEstado.adelantoInicialAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adel Ini Bonif')} />} valorCAC={subEstado.adelantoInicialBonifAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Cuota Espera')} />} valorCAC={subEstado.cuotaEsperaAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Cuota Espera Bonif')} />} valorCAC={subEstado.cuotaEsperaBonifAcumCAC} />} />

                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Recurrente')} />} valorCAC={subEstado.adelantoRecurrenteAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Recurrente Bonif')} />} valorCAC={subEstado.adelantoRecurrenteBonifAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Espontaneo')} />} valorCAC={subEstado.adelantoEspontaneoAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Adelanto Espontaneo Bonif')} />} valorCAC={subEstado.adelantoEspontaneoBonifAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Espera')} />} valorCAC={subEstado.refuerzoSemestralCuotaEsperaAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Espera Bonif')} />} valorCAC={subEstado.refuerzoSemestralCuotaEsperaBonifAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Recurrente')} />} valorCAC={subEstado.refuerzoSemestralAdelantoRecurrenteAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ref. Sem. C. Recurrente Bonif')} />} valorCAC={subEstado.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Prima Acum')} />} valorCAC={subEstado.primaAcumCAC} />} />
                      {/* <Grid conteiner rowSpacing={0} sx={{
    display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
    width: "100%"
  }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem'}} children={('Prima Acum Bonif')} />} valorCAC={subEstado.cuotaPrimaBonifAcumCAC} />} /> */}
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Cuota Posesion Acumulado')} />} valorCAC={subEstado.cuotaPosesionAcumCAC} />} />
                      <Grid conteiner rowSpacing={0} sx={{
                        display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
                        width: "100%"
                      }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem' }} children={('Ofer Lic')} />} valorCAC={subEstado.ofertaLicitatoriaAcumCAC} />} />
                      {/* <Grid conteiner rowSpacing={0} sx={{
    display: "inline-flex", justifyContent: "space-between", alignItems: "strech",
    width: "100%"
  }} children={<GridRow label={<Typography sx={{ paddingLeft: '1rem'}} children={('Ofer Lic Bonif')} />} valorCAC={subEstado.ofertaLicitatoriaBonifAcumCAC} />} /> */}
                    </AccordionDetails>
                  </Accordion>} />
                  <GridRow label='Capital Licitatorio' valorCAC={subEstado?.capitalLicitatorioCAC} />
                  <GridRow label='Prima Restante' valorCAC={subEstado?.primaRestanteCAC} />
                  <GridRow label='Mora' valorCAC={subEstado?.moraCAC} />
                  <GridRow label='Intereses Mora' valorCAC={subEstado?.interesesMoraCAC} />

                  <Grid item xs={12} />
                  <GridHeaders label='Pagos Generales' />
                  <GridRow label='Adelanto Inicial Restante' valorCAC={subEstado?.adelantoInicialRestanteCAC} />
                  <GridRow label='Adelanto Inicial Acumulado' valorCAC={subEstado?.adelantoInicialAcumCAC} />
                  <GridRow label='Oferta Licitatoria Restante' valorCAC={subEstado?.ofertaLicitatoriaRestanteCAC} />
                  <GridRow label='Oferta Licitatoria Acumulado' valorCAC={subEstado?.ofertaLicitatoriaAcumCAC} />

                  <Grid item xs={12} />
                  <GridHeaders label='Pagos Mes' />
                  <GridRow label='Obligación Mensual Total' valorCAC={obligacionTotalMensual} />
                  <GridRow label='Cuota Espera Mes Restante' valorCAC={subEstado?.cuotaEsperaMesRestanteCAC} />
                  <GridRow label='Cuota Espera Mes Acumulado' valorCAC={subEstado?.cuotaEsperaMesAcumCAC} />
                  <GridRow label='Cuota Prima Restante' valorCAC={subEstado?.cuotaPrimaMesRestanteCAC} />
                  <GridRow label='Cuota Prima Acumulado' valorCAC={subEstado?.cuotaPrimaMesAcumCAC} />
                  <GridRow label='Cuota Posesion Restante' valorCAC={subEstado?.cuotaPosesionRestanteCAC} />
                  <GridRow label='Cuota Posesion Acumulado' valorCAC={subEstado?.cuotaPosesionAcumCAC} />
                  <GridRow label='Adelanto Recurrente Mes Restante' valorCAC={subEstado?.adelantoRecurrenteMesRestanteCAC} />
                  <GridRow label='Adelanto Recurrente Mes Acumulado' valorCAC={subEstado?.adelantoRecurrenteMesAcumCAC} />
                  <GridRow label='Adelanto Espontaneo Mes Acumulado' valorCAC={subEstado?.adelantoEspontaneoMesAcumCAC} />

                  <Grid item xs={12} />
                  <GridHeaders label='Refuerzos Semestrales' />
                  <GridRow label='Obligación Mensual Refuerzos Total' valorCAC={obligacionTotalMensualRefuerzos} />
                  <GridRow label='Ref. Sem. C. Espera Restante' valorCAC={subEstado?.refuerzoSemestreCuotaEsperaRestanteCAC} />
                  <GridRow label='Ref. Sem. C. Espera Acumulado' valorCAC={subEstado?.refuerzoSemestreCuotaEsperaAcumCAC} />
                  <GridRow label='Ref. Sem. Adel. Recurrente Restante' valorCAC={subEstado?.refuerzoSemestreAdelantoRecurrenteRestanteCAC} />
                  <GridRow label='Ref. Sem. Adel. Recurrente Acumulado' valorCAC={subEstado?.refuerzoSemestreAdelantoRecurrenteaAcumCAC} />
                </Grid>)
              };
              const SubSubRow = ({ subOperacion, subEstado }) => {
                return <Accordion sx={{ backgroundColor: '#e8e8e8' }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                    <Grid container spacing={0}>
                      <Grid item xs={2} children={<Typography fontWeight={600} children={subOperacion.tipo} />} />
                      <Grid item xs={10} children={<OperacionInfo subEstado={subEstado} subOperacion={subOperacion} />} />
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <DetallesOp subEstado={subEstado} subOperacion={subOperacion} />
                  </AccordionDetails>
                </Accordion>
              }
              return <Accordion sx={{ backgroundColor: subOperacion ? '#f5f5f5' : '#e8e8e8', marginTop: '.75em' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                  <Grid container spacing={0}>
                    <Grid item xs={2} children={<Typography fontWeight={600} children={subOperacion.tipo} />} />
                    <Grid item xs={10} children={<OperacionInfo subEstado={subEstado} subOperacion={subOperacion} />} />
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  {subSubHistoria ? (subSubHistoria?.map((h, i, arr) => <SubSubRow key={'TabHistorial-Operacion-SubSubHistoria-' + i} {...h} />)) : <DetallesOp subEstado={subEstado} subOperacion={subOperacion} />}
                  {/* <DetallesOp subEstado={subEstado} subOperacion={subOperacion} /> */}
                </AccordionDetails>
              </Accordion>
            };
            const OperacionInfo = () => {
              let str = ``;
              switch (operacion.tipo) {
                case 'Creación':
                  str += `VendedorID: ${operacion.data.vendedorId} - `;
                  break;
                case 'Nuevo Mes':
                  str = ''
                  break;
                case 'Cambio de Tipología':
                  str += `ValorCAC: ${(valorContratoCAC)?.toFixed(2)} - `;
                  break;
                case 'Pago':
                  str += `Nominal: ${moneyFormat(operacion.data.montoNominal)} - `;
                  str += `CAC: ${(operacion.data.montoNominal / estado?.indice?.cac)?.toFixed(2)} - `;
                  str += `Fecha Carga: ${new Date(parseInt(operacion.data.fecha))?.toLocaleDateString()} - `;
                  break;
                case 'Pago Activado':
                  str += `Nominal: ${moneyFormat(operacion.data.montoNominal)}  `;
                  str += `CAC: ${(operacion.data.montoNominal / estado?.indice?.cac)?.toFixed(2)} - `;
                  str += `Fecha Valor: ${new Date(parseInt(operacion.data.fecha))?.toLocaleDateString()}  `;
                  str += `Tipo: ${operacion.data.descripcion}`;
                  break;
                case 'Pago En Espera':
                  str += `Nominal: ${moneyFormat(operacion.data.montoNominal)}  `;
                  str += `CAC: ${(operacion.data.montoNominal / estado?.indice?.cac)?.toFixed(2)} - `;
                  str += `Fecha Carga: ${new Date(parseInt(operacion.data.fechaValor))?.toLocaleDateString()}  `;
                  str += `Tipo: ${operacion.data.descripcion}`;
                  break;
                default:
                  str += `CAC: ${operacion.data.montoCAC} - `;
                  str += `Bonificación CAC: ${operacion.data.bonificacionCAC} - `;
                  str += `Cancelación Total: ${operacion.data.cancelacionTotal} - `;
                  break;
              }

              return <Typography fontWeight={500} children={str} />;
            };
            const { pagosActivables } = estado;
            return <Accordion sx={{ backgroundColor: '#e8e8e8', marginTop: '.75em' }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                <Grid container spacing={0}>
                  <Grid item xs={2} children={<Typography fontWeight={600} children={operacion.tipo} />} />
                  <Grid item xs={6} children={<OperacionInfo />} />
                  <Grid item xs={2} children={<Typography fontWeight={500} children={new Date(operacion.fecha).toLocaleString()} />} />
                  <Grid item xs={0.5} children={<PagosActivablesButton pagosActivables={pagosActivables} />} />
                  <Grid item xs={0.5} children={<CampanasActivasButton campanasActivas={campanasActivas} />} />
                  <Grid item xs={0.5} children={<TitularidadesButton titularidadesActuales={titularidadesActuales} />} />
                  <Grid item xs={0.5} children={<ContratoActualButton contratoActual={contratoActual} />} />
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                {subHistoria?.map((h, i, arr) => <SubRow key={'TabHistorial-Operacion-SubHistoria-' + i} {...h} />)}
              </AccordionDetails>
            </Accordion>;
          };

          return props.subHistoria ? <SubHistoriaRow {...props} /> : <NoSubHistoriaRow {...props} />;
        };

        return (<Grid container spacing={0}>
          <Grid>
            {sortedEstados?.map((h, i, arr) => <Grid key={`sortedEstados-${i}`} item xs={12} children={<Operacion {...h} />} />)}
          </Grid>
        </Grid>)
      };
      const TitularidadesTab = props => {
        const titulares = detalles?.titularidades.map(t => {
          let persona = (personas || [])?.find(p => p.personaId === t.personaId)
          return ({
            ...persona,
            nombreTitular: persona.personaFisica ? persona.nombre + ' ' + persona.apellido + ' - Número Documento: ' + persona.numeroDocumento
              : persona.denominacionSocial + ' - CUIT: ' + persona.CUIT,
            porcentaje: t.partes,
            titularPrincipal: t.titularPrincipal ? 'Principal' : 'Secundaria',
            activo: persona.activo ? 'Activo' : 'No activo',
            telefono: persona.telefono1 ? persona.telefono1 : persona.telefono2 ? persona.telefono2 : '-'
          })
        });
        return (
          <Fragment>
            {titulares?.map((titular, i) => {
              return (
                <Card sx={{ minWidth: 275, margin: '10px' }} key={`card-Titulares-${titular.email}`}>
                  <CardContent>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                      {`Email: ${titular.email}   Tel: ${titular.telefono}   Estado: ${titular.activo}`}
                    </Typography>
                    <Typography variant="h6" component="div">
                      Titular ID: {titular.personaId} - {titular.nombreTitular}
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                      {titular.porcentaje.toFixed(2)} % Titularidad {titular.titularPrincipal}
                    </Typography>
                  </CardContent>
                </Card>
              )
            })}
          </Fragment>
        )
      };
      const MinutaTab = props => {
        const [loadingMinuta, setLoadingMinuta] = useState(false);
        const generatePDF = async (id) => {
          setLoadingMinuta(true); // Activa el indicador de carga
          try {
            const report = new jsPDF('portrait', 'pt', 'a4');
            await report.html(document.querySelector('#' + id));
            report.save('Minuta_Comercial.pdf');
          } catch (error) {
            console.error(error);
            // Manejo de errores si es necesario
          } finally {
            setLoadingMinuta(false); // Desactiva el indicador de carga, independientemente del resultado
          }
        };
        let titulares = (detalles ? detalles?.historia[0]?.titularidadesActuales : [])?.map(t => (personas || [])?.find(p => p.personaId === t.personaId))
        let contrato = detalles ? ({
          ...detalles?.historia[0]?.contratoActual,
          refuerzo: detalles?.contrato?.mesRefuerzoSemestral1 === null ? false : true, cochera: false, baulera: false
        }) : {}
        let estado = detalles ? detalles?.historia[0]?.estado : [];
        let claseContrato = detalles ? detalles?.historia[0]?.claseContratoActual : [];
        return (
          <>
            <Grid container direction="row-reverse" justifyContent="center" alignItems="flex-start">
              {loadingMinuta ? <div style={{ display: "flex", margin: "1em", }}> <div className="loading-screen" style={{ marginTop: "0.5em", marginRight: "0.5em" }}> Descargando PDF...</div> <ClipLoader
                sx={{ marginTop: "0.5em" }}
                color={theme.palette.success.main}
                loading={loadingMinuta}
                size={30}
                aria-label="Loading Spinner"
                data-testid="loader"
              /> </div> : <Button onClick={() => generatePDF("minuta-comercial")}>Descargar <FileDownloadIcon /></Button>}

              <MinutaContrato
                contrato={contrato}
                claseContrato={claseContrato}
                claseContratoConsolidada={claseContrato}
                estado={estado}
                titulares={titulares}
                segundaHoja={false}
                contratoDpto={{}}
                contratoCochera={{}}
                contratoBaulera={{}}
                claseCochera={{}}
                claseBaulera={{}}
                MESES_LAG={MESES_LAG}
              />
            </Grid>
          </>
        )
      };
      const DocTab = props => {
        function ExcelPreview(props) {
          const [excelData, setExcelData] = useState(null);

          useEffect(() => {
            const fetchData = async () => {
              try {
                const response = await fetch(props.excelFile);
                const buffer = await response.arrayBuffer();
                const workbook = XLSX.read(buffer, { type: 'buffer' });
                const worksheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[worksheetName];
                const data = XLSX.utils.sheet_to_json(worksheet);
                setExcelData(data.slice(0, 10));
              } catch (error) {
                console.error('Error fetching Excel file:', error);
              }
            };

            fetchData();
          }, [props.excelFile]);

          return (
            excelData ? (
              <div style={{ height: '20vh', width: '20vh' }}>
                <table className="table">
                  <thead>
                    <tr>
                      {Object.keys(excelData[0]).map((key) => (
                        <th key={key}>{key}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {excelData.map((individualExcelData, index) => (
                      <tr key={index}>
                        {Object.keys(individualExcelData).map((key) => (
                          <td key={key}>{individualExcelData[key]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div>
                Vista previa no disponible. Haz click {" "}
                <a href={props.excelFile} target="_blank" rel="noopener noreferrer">
                  aquí
                </a>
              </div>
            )
          );
        };
        function FilePreview(props) {
          const doc = props.doc
          const keyArray = doc?.key?.split('.');
          const fileExtension = keyArray[keyArray?.length - 1]?.toLowerCase()

          // Render different components based on file extension
          switch (fileExtension) {
            case 'png':
            case 'jpg':
            case 'jpeg':
              return <img style={{ height: '10vh', width: '15vh' }} src={doc.signedUrl} alt="Preview" />;
            case 'pdf':
            case 'html':
              return <iframe style={{ height: '20vh', width: '15vh' }} src={doc.signedUrl} title={doc.key} />;
            case 'xlsx':
              return <ExcelPreview key={'excel-' + doc.key} excelFile={doc.signedUrl} />;
            case 'mp4':
            case 'avi':
            case 'mov':
              return <video style={{ height: '10vh' }} controls src={doc.signedUrl} />;
            default:
              return (
                <div>
                  Vista previa no disponible. Haz click {" "}
                  <a href={doc.signedUrl} target="_blank" rel="noopener noreferrer">
                    aquí
                  </a>
                </div>
              );
          }
        };
        const handleDownload = async (signedUrl, fileName) => {
          try {
            const response = await fetch(signedUrl); // Fetch the file from the signed URL
            if (!response.ok) {
              throw new Error('Failed to fetch file');
            }
            const fileBlob = await response.blob(); // Convert the response to a blob
            saveAs(fileBlob, fileName); // Save the blob as a file with the given filename
          } catch (error) {
            console.error('Error downloading file:', error);
          }
        };
        const getReferenciaDocumento = (doc) => {
          let refId = doc.refId;
          let tabla = doc.nombreTabla;
          switch (tabla) {
            case 'Contratos':
              return 'Contrato'
            case 'Campanas':
              return `Campana: ${tiposCampana?.find(tc=> tc.tipoCampanaId === detalles?.campanas?.find(c=> c.campanaId === refId)?.tipoCampanaId)?.nombre}`
            default:
              break;
          }
        }

        const rows = (documentos || [])?.filter(d => (d.nombreTabla === 'Campanas' && detalles?.campanas?.map(c => c.campanaId)?.includes(d.refId)) || (d.nombreTabla === 'Contratos' && d.refId === contratoSeleccionado))
        const columns = [
          { field: 'documentoId', headerName: 'DocumentoID', hide: true },
          { field: 'signedUrl', headerName: 'Preview', width: 100, renderCell: v => <FilePreview key={'file-key' + v.row.documentoId} style={{ height: '10vh', width: '10vh' }} doc={v.row} /> },
          { field: 'nombre', headerName: 'Nombre ', width: 400 },
          {
            field: 'key', headerName: 'Extensión', width: 100, valueGetter: v => {
              const keyArray = v.row?.key?.split('.');
              return keyArray[keyArray?.length - 1]?.toLowerCase()
            }
          },
          {
            field: 'editorId', headerName: 'Autor', width: 100,
            valueGetter: ({ value, row }) => getNombrePersona(row?.editorId),
          },
          { field: 'fechaEdición', headerName: 'Fecha Carga', width: 100, renderCell: v => (new Date(parseInt(v.row.fechaEdicion))).toLocaleString().split(',')[0] },
          {
            field: 'nombreTabla', headerName: 'Referencia', width: 200, valueGetter: v => getReferenciaDocumento(v.row)
          },
          {
            field: 'actions', headerName: 'Acciones', width: 100, type: 'actions', renderCell: v =>
              <>
                {/* <GridActionsCellItem key={v.row.documentoId + '-descargaGridAction'} disabled={currentUser?.permisos?.includes("export-data") ? false : true} color={'info'} onClick={() => handleDownload(v.row.signedUrl, v.row.nombre)} icon={<GridAction label={'Descarga'} Icon={FileDownloadIcon} />} /> */}
                <GridActionsCellItem key={v.row.documentoId + '-descargaGridAction'} disabled={currentUser?.permisos?.includes("export-data") ? false : true} color={'info'} onClick={() => handleOpenUrl(v.row.signedUrl)} icon={<GridAction label={'Abrir'} Icon={OpenInNewIcon} />} />
                <GridActionsCellItem key={v.row.documentoId + '-borrarGridAction'} disabled={currentUser?.permisos?.includes("export-data") ? false : true} color={'danger'} onClick={() => { dispatch(delDoc([v.row.documentoId])) }} icon={<GridAction label={'Eliminar'} Icon={DeleteIcon} />} />

              </>
          }
        ];
        return (
          <Grid container direction="column" sx={{ display: 'flex', justifyContent: 'space-around' }}>
            {rows?.length > 0 ?
              <DataGridPro
                pagination
                sx={{ height: '75vh', width: '100%' }}
                getRowId={r => r.documentoId}
                rows={(rows || [])}
                columns={columns}
                components={{
                  Toolbar: () => {
                    return <Fragment>
                      <GridToolbarContainer>
                        <Grid conteiner
                          rowSpacing={0} sx={{
                            display: "inline-flex",
                            justifyContent: "space-between",
                            alignItems: "strech",
                            width: "100%"
                          }}>
                          <Grid sx={{ width: "100%" }}>
                            <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                            {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                              : ''}
                          </Grid>
                          <GridToolbarQuickFilter />
                        </Grid>
                      </GridToolbarContainer>
                    </Fragment>
                  }
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [{ field: 'documentoId', sort: 'desc' }],
                  },
                  innedColumns: { right: ['actions'] }
                }}
                loading={fetching > 0}
              />
              : <Typography children={'No hay documentos cargados del contrato.'} />}
          </Grid>
        )
      };
      return (
        <Dialog TransitionComponent={Grow} disableAutoFocus open={showDetallesContrato} fullWidth={true} maxWidth='xl' >
          <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Detalles Contrato ID {contratoSeleccionado}:</DialogTitle>
          <DialogContent dividers>
            <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
              <Grid container
                direction="row"
                justifyContent="space-between"
                alignItems="center">
                <Grid><Tabs value={selectedTab} onChange={(event, newValue) => setSelectedTab(newValue)} >
                  <Tab sx={{ fontWeight: "bold" }} label="General" id={0} />
                  <Tab sx={{ fontWeight: "bold" }} label="Historial" id={1} />
                  <Tab sx={{ fontWeight: "bold" }} label="Titulares" id={2} />
                  <Tab sx={{ fontWeight: "bold" }} label="Minuta Comercial" id={3} />
                  <Tab sx={{ fontWeight: "bold" }} label="Documentos" id={4} />
                </Tabs></Grid>
                <Grid ><Button
                  sx={{ fontWeight: "bold", }}
                  variant="text"
                  component="button"
                  size="small"
                  onClick={() => handleDownload()}>
                  Descargar pagos <FileDownloadIcon></FileDownloadIcon>
                </Button></Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1, paddingTop: '1.5rem', width: '100%', borderBottom: 1, borderColor: 'divider', height: '70vh' }}>
              {selectedTab === 0 ? <GeneralTab /> : null}
              {selectedTab === 1 ? <HistorialTab /> : null}
              {selectedTab === 2 ? <TitularidadesTab /> : null}
              {selectedTab === 3 ? <MinutaTab sx={{ minHeight: "850px" }} /> : null}

              {selectedTab === 4 ? <DocTab sx={{ minHeight: "850px" }} /> : null}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" sx={{ fontWeight: "bold" }} onClick={() => { setShowDetallesContrato(false); setContratoSeleccionado(null) }}>Volver</Button>
          </DialogActions>
        </Dialog >)
    };
    function handleExportacionPagos() {
      const getImporteEsperadoCAC = (subHistoria) => {
        let tipoOperacion = subHistoria.subOperacion?.tipo
        let property = ''
        switch (tipoOperacion) {
          case 'Pago Cuota Espera':
            property = 'cuotaEsperaMesRestanteCAC'
            break;
          case 'Pago Adelanto Recurrente':
            property = 'adelantoRecurrenteMesRestanteCAC'
            break;

          case 'Pago Adelanto Inicial':
            property = 'adelantoInicialRestanteCAC'
            break;

          case 'Pago Mora':
            property = 'moraCAC'
            break;

          case 'Pago Refuerzo Cuota Semestral':
            property = 'refuerzoSemestreCuotaEsperaRestanteCAC'
            break;
          case 'Pago Refuerzo Cuota Semestral':
            property = 'refuerzoSemestreAdelantoRecurrenteRestanteCAC'
            break;
          case 'Pago Prima':
            property = 'primaRestanteCAC'
            break;
          case 'Pago Adelanto Espontaneo':
            return 0
          default:
            break;
        }
        return subHistoria.subEstado[property] + subHistoria.subOperacion?.data?.montoCAC
      };
      const getCampanasVigentes = (campanas) => {
        let campanasCell = []
        campanas?.forEach(c => {
          let tipoCampana = tiposCampana?.find(t => t.tipoCampanaId === c.tipoCampanaId)?.nombre;
          campanasCell.push(tipoCampana + `(${c.parametros.porcentaje})`);
        });
        return campanasCell.join(' - ')
      };
      const getPorcentajeBonificacion = (subHistoria) => {
        let tipoOperacion = subHistoria.subOperacion?.tipo
        let porcentaje = ''
        let montoBoni = subHistoria.subOperacion?.data?.bonificacionCAC > 0.00 ? subHistoria.subOperacion?.data?.bonificacionCAC : 0
        let estado = subHistoria.subEstado
        switch (tipoOperacion) {
          case 'Pago Cuota Espera':
            porcentaje = montoBoni / (estado['cuotaEsperaMesAcumCAC'])
            break;
          case 'Pago Adelanto Recurrente':
            porcentaje = montoBoni / (estado['adelantoRecurrenteMesAcumCAC'])
            break;

          case 'Pago Adelanto Inicial':
            porcentaje = montoBoni / (estado['adelantoInicialAcumCAC'])
            break;

          case 'Pago Mora':
            porcentaje = montoBoni / (subHistoria.subOperacion?.data.montoCAC)
            break;

          case 'Pago Refuerzo Cuota Semestral':
            porcentaje = montoBoni / (estado['refuerzoSemestreCuotaEsperaAcumCAC'])
            break;
          case 'Pago Refuerzo Cuota Semestral':
            porcentaje = montoBoni / (estado['refuerzoSemestreAdelantoRecurrenteAcumCAC'])
            break;
          case 'Pago Prima':
            porcentaje = montoBoni / (estado['primaRestanteCAC'])
            break;
          case 'Pago Adelanto Espontaneo':
            porcentaje = montoBoni / (subHistoria.subOperacion?.data.montoCAC)
          default:
            break;
        }
        return porcentaje
      }
      const CAC2Nominal = (montoCac, fecha) => montoCac * getIndiceAt(fecha, -2).cac;
      let catarataPagos = [];
      (contratos || [])?.forEach(c => c.historia.forEach((h, i) => { if (h.subHistoria) catarataPagos?.push(h.subHistoria?.map(sh => ({ ...sh, contratoId: c.contratoId, clase: h.claseContratoActual?.codigo, importeEsperadoCAC: getImporteEsperadoCAC(sh), porcentualBonif: getPorcentajeBonificacion(sh), campanas: getCampanasVigentes(h.campanasActivas) }))) }));
      catarataPagos = catarataPagos.flat()
      const datos = catarataPagos?.map((c) => [
        c.contratoId,
        c.clase,
        getFecha(c.subEstado?.fecha),
        c.subOperacion.tipo,
        c.subOperacion?.data?.cancelacionTotal ? 'Sí' : 'No',
        moneyFormat(CAC2Nominal(c.importeEsperadoCAC, c.subEstado?.fecha)?.toFixed(2)),
        moneyFormat(CAC2Nominal(c.subOperacion?.data?.montoCAC, c.subEstado?.fecha)?.toFixed(2)),
        //Bonif. Porcentual
        c.porcentualBonif.toFixed(2),
        //((((c.subOperacion?.data?.bonificacionCAC > 0.00 ? c.subOperacion?.data?.bonificacionCAC : 0.00)) / c.subOperacion?.data?.montoCAC))?.toFixed(2),
        moneyFormat(CAC2Nominal(c.subOperacion?.data?.bonificacionCAC > 0.00 ? c.subOperacion?.data?.bonificacionCAC : 0.00, c.subEstado?.fecha)?.toFixed(2)),
        c.campanas,
        '',
        getFecha(c.subEstado?.indice.fecha),
        moneyFormat(c.subEstado?.indice.cac)

      ]);
      catarataPagos = catarataPagos.flat()
      // Crear el libro de trabajo de Excel
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet([
        [
          'Contrato ID',
          'Tipología',
          'Fecha Pago',
          'Tipo',
          'Cancelación',
          'Importe Esperado',
          'Importe Computado',
          'Bonif. Pocentual',
          'Bonificación',
          'Campanas Vigentes',
          '',
          'Fecha Indice',
          'CAC',
        ],
        ...datos,
      ]);
      // Configurar el ancho de las columnas
      const columnWidths = [
        { wch: 15 }, // Ancho de la columna CBU
        { wch: 20 }, // Ancho de la columna Importe
        { wch: 15 }, // Ancho de la columna CBU
        { wch: 25 }, // Ancho de la columna Importe
        { wch: 15 }, // Ancho de la columna Partida
        { wch: 15 }, // Ancho de la columna Referencia
        { wch: 15 }, // Ancho de la columna Referencia
        { wch: 15 }, // Ancho de la columna Fecha Presentación
        { wch: 15 }, // Ancho de la columna Fecha Vencimiento
        { wch: 15 }, // Ancho de la columna Nombre Adherente
        { wch: 25 }, // Ancho de la columna Fecha Vencimiento
      ];
      worksheet['!cols'] = columnWidths;

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

      // Generar el archivo Excel
      const excelBuffer = XLSX.write(workbook, {
        type: 'array',
        bookType: 'xlsx',
      });

      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Cataratas_Pagos_contratos.xlsx`;
      link.click();
      URL.revokeObjectURL(url);
    };

    return (<>
      {showEditarContratoForm ? <EditarContratoForm /> : null}
      {showDeleteContratoConfirmation ? <DeleteContratoConfirmation /> : null}
      {showUploadForm ? <CargarArchivosForm /> : null}
      {showDetallesContrato ? <DetallesContratoModal /> : null}
      <FirmarContratoForm />

      <ModalPerfeccionamiento />
      <Box fullWidth>
        <DataGridPro
          fullWidth
          pagination
          sx={{ height: '75vh', scale: 1 }}
          getRowId={r => r.contratoId}
          rows={rows}
          columns={columns}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={setColumnVisibilityModel}
          components={{
            Toolbar: () => {
              return <Fragment>
                <GridToolbarContainer>
                  <Grid conteiner
                    rowSpacing={0} sx={{
                      display: "inline-flex",
                      justifyContent: "space-between",
                      alignItems: "strech",
                      width: "100%"
                    }}>
                    <Grid sx={{ width: "100%" }}>
                      <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                      {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> <Button size="small" style={{ zoom: '1' }} sx={{ padding: '0rem' }} onClick={handleExportacionPagos}><SaveAltIcon style={{ zoom: '0.75', marginRight: '0.5rem' }} />  Exportar Pagos</Button></>
                        : ''}
                    </Grid>
                    <GridToolbarQuickFilter />
                  </Grid>
                </GridToolbarContainer>
              </Fragment>
            }
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          initialState={{
            sorting: {
              sortModel: [{ field: 'contratoId', sort: 'desc' }],
            },
            innedColumns: { right: ['actions'] }
          }}
          loading={fetching > 0}
        />
      </Box>
    </>)
  };
  // const getCuotasEquivalentes = () => {
  //   let ultimosEstados = (contratos || [])?.map(c => {
  //     let ultimaHistoria = _.last(c.historia)
  //     let valor = getConversionesCAC(ultimaHistoria?.estado?.valorCAC, { ...ultimaHistoria?.estado?.indice, cac: parseInt(ultimaHistoria?.estado?.indice?.cac) }, { ...ultimaHistoria?.claseContratoActual })

  //     return ({
  //       indice: ultimaHistoria?.estado?.indice,
  //       contratoId: c.contratoId,
  //       valorCAC: ultimaHistoria?.estado?.valorCAC,
  //       gradoAvance: parseFloat((valor?.ga * 100)?.toFixed(2)),
  //       cuotasEq: parseFloat(valor?.cuotasEq?.toFixed(2))
  //     })
  //   })
  //   return ultimosEstados
  // };
  return (<>
    <Header />
    <ContratosTable />
  </>)
};

export default ContratosCat;

